﻿{
  "features.store.tabDatedBrochures": "Datierte Broschüren",
  "features.leadCapture.company.invalidTagHtml": "Geben Sie <strong>G-</strong> nicht als Teil des Codes ein.",
  "common.buttons.reset": "Zurücksetzen",
  "features.dashboard.checklist.step5": "5. Designer für die Lead-Erfassung einrichten",
  "common.menu.orders": "Aufträge",
  "common.labels.sales": "Vertrieb",
  "features.basket.glazing": "Verglasung",
  "features.costsPrices.labels.bottomLeft": "Unten links",
  "common.labels.subject": "Betreff",
  "common.buttons.close": "Schließen",
  "features.dashboard.knowledgeBase.hideArticle": "Artikel ausblenden",
  "features.productSettings.noOptionsAvailable": "Keine Optionen verfügbar",
  "features.leadCapture.company.paperwork": "Geben Sie hier den Inhalt ein, der auf Ihren an Kunden versendeten Unterlagen angezeigt wird.",
  "common.datetime.thu": "Donnerstag",
  "features.basket.viewSummary": "Zusammenfassung anzeigen",
  "common.datetime.fr": "Fr",
  "features.leadCapture.company.googleAnalytics.step3.part2": "Klicken Sie auf den Link und prüfen Sie, ob die URL der Ziel-Domain den Linker-Parameter _gl enthält.",
  "features.leadCapture.hero.activeLine1": "Holen Sie das Beste aus",
  "features.switchDesign.noDesignsMatch": "Keine {name}-Designs entsprechen {search}.",
  "features.chooseProduct.createDesign": "Design erstellen",
  "features.designer.issueProhibition": "Verbot",
  "common.status.cancelled": "Abgebrochen",
  "features.designer.selectedExtras": "Ausgewählte Zusatzoptionen",
  "common.buttons.next": "Weiter",
  "common.labels.status": "Status",
  "features.paymentGateway.manageStripeAccount": "Stripe-Konto verwalten",
  "features.basket.fitting": "Montage",
  "common.labels.commercial": "Gewerbe",
  "common.datetime.minute": "Minute",
  "features.leadCapture.company.invalidTag": "Ungültiges Google-Tag",
  "features.designer.customDesigner.descShape": "Wählen Sie eine Standardform passend zu Ihren Maßen oder erstellen Sie eine eigene Form, indem Sie 'Benutzerdefinierte Form' aktivieren und Punkte im Raster verschieben.",
  "features.productSettings.subscriptionType": "Lizenztyp",
  "common.menu.productSpecifications": "Technische Daten",
  "features.support.knowledgeBaseDescription": "Besuchen Sie unsere Wissensdatenbank mit zahlreichen Videos zu allen Funktionen von {product}.",
  "features.quotesAndOrders.location": "Standort",
  "common.labels.source": "Quelle",
  "common.financial.subtotalDiscounted": "Zwischensumme (rabattiert)",
  "common.validation.unSavedChangesForm": "Dieses Formular enthält nicht gespeicherte Änderungen.",
  "features.account.makeDefault": "Als Standard festlegen",
  "common.validation.rules.requiredMultiple": "Mindestens ein Feld in {field} ist leer.",
  "features.staff.licenseLimitExpressHtml": "Sie haben Ihr Benutzerlizenzlimit erreicht. Bitte besuchen Sie {account}, um Ihr Limit zu erhöhen.",
  "common.financial.supplyFitExtrasCharge": "Aufpreis für Extras bei Lieferung & Montage",
  "features.designer.chooseExtra": "Zusatzoption auswählen",
  "features.customers.contactEmail": "Kontakt-E-Mail",
  "common.labels.categories": "Kategorien",
  "features.store.liteInterface": "'Lite' – die einfach zu bedienende Benutzeroberfläche",
  "common.labels.none": "Keine",
  "common.datetime.su": "So",
  "common.datetime.sat": "Sa",
  "features.designer.customiseProduct": "Produkt anpassen",
  "common.errors.feedbackSubmitted": "Feedback gesendet. Vielen Dank!",
  "features.account.requoteTaxValue": "Steuern neu berechnen",
  "features.chooseProduct.noDesignsAvailable": "Es sind keine Designs verfügbar",
  "common.labels.colour": "Farbe",
  "features.leadCapture.styling.enquiryPdfImage1Purpose": "Ergänzen Sie Ihre Unterlagen mit einem Produktfoto.",
  "features.store.oneMonthFree": "{brandedMode} mit EINEM MONAT KOSTENLOS",
  "features.costsPrices.labels.band": "Band",
  "features.costsPrices.strategy1Step2PerOptionSuffix": "Seiten",
  "features.basket.showFullBasket": "Gesamten Warenkorb anzeigen",
  "features.productSettings.addType": "Typ hinzufügen",
  "common.validation.pleaseCheckInput": "Bitte überprüfen Sie Ihre Eingabe",
  "features.costsPrices.labels.minHeightShort": "Mindesthöhe",
  "features.costsPrices.labels.list": "Liste",
  "features.productSettings.availableToOrder": "Bestellbar",
  "features.quotesAndOrders.isExpired": "{contractType} ist abgelaufen.",
  "common.menu.slabGlassBands": "Ganzglas-Türenbänder",
  "common.financial.surveyCharge": "Aufmaßgebühr",
  "common.global.privacyPolicyName": "Datenschutzerklärung",
  "features.login.returnToLogin": "Zurück zur Anmeldung",
  "features.paymentGateway.finishStripeSetupLink": "Folgen Sie dem Link, um die Einrichtung von Stripe abzuschließen.",
  "common.errors.somethingWentWrong": "Es ist ein Fehler aufgetreten",
  "common.contact.tel": "Tel.",
  "common.labels.viewAssigned": "Zugewiesene anzeigen",
  "features.costsPrices.labels.measurePerM": "Pro m",
  "features.leadCapture.styling.virtualHomeBanner": "Virtual Home Banner",
  "features.leadCapture.company.googleAnalytics.step4.part2": "Öffnen Sie den Google-Analytics-Echtzeitbericht. Der Ereignisname sollte in der Kachel mit mindestens einer Conversion angezeigt werden.",
  "common.menu.selections": "Auswahlmöglichkeiten",
  "features.leadCapture.deployment.deploy": "Einrichten",
  "features.costsPrices.strategy2Step1PerOptionPrefix": "Preise pro Option hinzufügen in",
  "features.dashboard.knowledgeBase.articles.title0": "{0} Einrichtungs-Checkliste",
  "features.store.paidByFabricatorUntil": "Wird vom Hersteller bezahlt bis {date}",
  "features.dashboard.knowledgeBase.link": "Mein Konto",
  "features.costsPrices.labels.customerPrices": "Kundenpreise",
  "features.customers.inactive": "inaktiv",
  "common.validation.invalidData": "Ungültige Daten",
  "common.status.saving": "Speichern",
  "features.dashboard.checklist.step3": "3. Unterlagen individuell anpassen",
  "features.basket.submitEnquiry": "Anfrage absenden",
  "features.store.convertingText": "Nachdem Sie Ihr Angebot an den Kunden gesendet haben, können Sie daraus einen Auftrag erstellen. Dieser wird anschließend an {fabricator} übermittelt.",
  "features.enquiries.leadCapture.title": "Endkundenanfragen generieren",
  "features.leadCapture.hero.expiringLine3": "für {touch} ist...",
  "common.contact.emailAddress": "E-Mail-Adresse",
  "features.account.voucherAccountLimit": "Kontolimit",
  "features.leadCapture.company.googleAnalytics.step2.part1": "Öffnen Sie die Google-Analytics-Startseite, die mit dem oben angegebenen gtag verknüpft ist.",
  "features.productSettings.sourceOverlaps": "Referenzüberstände",
  "features.designer.itemDeleted": "Artikel gelöscht",
  "features.designer.previousQuestion": "Vorherige Frage",
  "features.costsPrices.labels.financialCategory": "Preiskategorie",
  "features.customers.extruderFeatureQuotesAndOrders": "Angebote & Bestellungen",
  "features.costsPrices.labels.jointTAngledWeld": "Abgewinkelte T-Verbindung – geschweißt",
  "features.quotesAndOrders.release": "Veröffentlichung",
  "common.financial.deliveryCharge": "Versandkosten",
  "common.labels.facets": "Facetten",
  "features.costsPrices.labels.groupName": "Gruppenname",
  "features.customers.useCustomerCharge": "Kundengebühr verwenden",
  "common.menu.enquiries": "Anfragen",
  "common.status.active": "Aktiv",
  "features.visualiser.uploadStep4": "4. Größe und Ausrichtung Ihrer Produkte anpassen.",
  "features.store.generatingEnquiriesProblem": "In einem hart umkämpften Markt kann es schwierig sein, online Anfragen zu generieren.",
  "features.leadCapture.styling.enquiryPdfImage2": "Bild 2 für das Anfrage-PDF",
  "common.errors.serverNotReached": "Derzeit kann keine Verbindung zu unseren Servern hergestellt werden. Bitte prüfen Sie Ihre Internetverbindung oder versuchen Sie es erneut.",
  "features.account.enterNewLink": "Geben Sie einen neuen Link ein...",
  "features.quotesAndOrders.unlock": "{contractType} freischalten",
  "features.support.manageNewsDescription": "Veröffentlichen Sie News, die Ihren Kunden im Portal angezeigt werden. Präsentieren Sie Produkte sowie Branchen- und Unternehmensinformationen.",
  "common.labels.verification": "Überprüfung",
  "features.quotesAndOrders.featureUnavailableTitle": "Funktion nicht verfügbar",
  "features.quotesAndOrders.convertToOrder": "In Bestellung umwandeln",
  "features.basket.completeFormBelow": "Bitte füllen Sie das untenstehende Formular aus.",
  "features.leadCapture.styling.thankYouPageTitle": "Titel der Dankeseite",
  "features.quotesAndOrders.yourCost": "Ihre Kosten",
  "features.checkout.redirectingToPayment": "Weiterleitung zum Zahlungsanbieter",
  "features.launch.tradeCustomer": "Fachhändler?",
  "common.status.declined": "Abgelehnt",
  "features.leadCapture.setup.businessDocuments": "Geschäftsdokumente",
  "features.leadCapture.styling.landingPageText": "{setup} Text der Landingpage",
  "common.status.archived": "Archiviert",
  "features.visualiser.uploadStep2": "2. Wählen Sie Innen- oder Außenansicht aus",
  "features.enquiries.noneReceived": "Keine Anfragen eingegangen",
  "common.menu.discountCategories": "Rabattkategorien",
  "features.visualiser.visSavedTitle": "Visualisierung gespeichert.",
  "common.buttons.confirm": "Bestätigen",
  "features.launch.yesHint": "Klicken Sie auf {button}, wenn Ihnen die Maße Ihrer Fenster und/oder Türen bekannt sind.",
  "common.status.saveFailed": "Speichern fehlgeschlagen",
  "features.retailOptionsControl.selectedHeading": "Ausgewählte Überschrift",
  "features.news.deleteCategoryTitle": "Sind Sie sicher, dass Sie diese Kategorie löschen möchten?",
  "features.enquiries.leadCapture.button": "Einrichtung {retail}",
  "common.labels.verificationIs": "Überprüfung {is} {status}",
  "common.financial.hideFinancials": "Finanzdaten ausblenden",
  "features.dashboard.knowledgeBase.undoHide": "Rufen Sie {0} auf, um diese Änderung rückgängig zu machen.",
  "common.buttons.refuse": "Ablehnen",
  "features.designer.quickTipExample": "Wählen Sie beispielsweise das Glas aus, um den Glastyp zu ändern, Zierabstandhalter hinzuzufügen oder weitere Anpassungen vorzunehmen.",
  "features.store.howToBuy": "{brandedMode} kaufen",
  "features.staff.editStaffMember": "Mitarbeiter bearbeiten",
  "features.costsPrices.allSizesNote": "Alle im Raster eingegebenen Maße gelten für alle Ausführungen, auch wenn Grenzwerte überschritten werden.",
  "features.leadCapture.hero.activeList2": "Ideen für Banner und Schaltflächen",
  "features.costsPrices.labels.units": "Einheiten",
  "features.designer.noSpecsFoundTitle": "Keine Spezifikationen gefunden",
  "features.chooseProduct.noGroupsFoundText": "{companyName} muss mindestens eine Produktgruppe und einen Produkttyp einrichten.",
  "features.leadCapture.company.yourAddress": "Ihre Adresse",
  "common.financial.paymentPending": "Zahlung ausstehend",
  "features.basket.designMoreProducts": "Weitere Produkte entwerfen",
  "common.labels.pleaseSelect": "Bitte wählen Sie",
  "features.account.voucherLimitedTo": "Beschränkt auf",
  "features.checkout.logOrderWith": "Auftrag bei {name} erfassen",
  "features.designer.noOptionSelected": "Keine Option ausgewählt",
  "features.basket.internalColour": "Innenfarbe",
  "features.basket.customerName": "Kunde ({name})",
  "features.login.username": "Benutzername",
  "features.store.buyNow": "Jetzt kaufen",
  "common.labels.license": "Lizenz",
  "features.launch.designerUnavailable": "Designer nicht verfügbar.",
  "features.quotesAndOrders.downloadBayBowsLayout": "Erkerlayout herunterladen",
  "features.chooseProduct.selectType": "Typ auswählen",
  "features.quotesAndOrders.yourSellingPrice": "Ihr Verkaufspreis (ohne MwSt.)",
  "features.chooseProduct.partsListSearchPlaceholder": "Nach Code/Beschreibung suchen ... (mind. 3 Zeichen)",
  "features.visualiser.uploadTip6": "Gut auf den relevanten Bereich zentriert.",
  "features.login.step1": "Bitte geben Sie Ihre Daten ein",
  "features.delivery.latitudeLongitudeRequired": "Breitengrad & Längengrad sind für die geografische Auswahl über Anfragen erforderlich.",
  "features.customers.customerList": "Kundenliste",
  "features.account.companyRegistrationNumber": "Handelsregisternummer",
  "features.designer.modelErrorText": "Fehler beim Laden des 3D-Modell-Viewers. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.",
  "features.account.disablePortalProcessing": "Portalverarbeitung deaktivieren",
  "features.leadCapture.styling.thankYouPageBackgroundLocation": "Bereich: {setup} Dankeseite",
  "features.leadCapture.styling.landingPageBackgroundLocation": "Position: {setup} Einführungsseite des Designers {setup}",
  "features.login.description": "Weiter zum Dashboard",
  "common.buttons.replace": "Ersetzen",
  "features.designer.searchByOptionName": "Nach Optionsnamen suchen ...",
  "features.costsPrices.labels.baseSashPrice": "Grundpreis Flügel",
  "features.quotesAndOrders.viewOrder": "Auftrag anzeigen",
  "features.productSettings.optionHeading": "Optionsüberschrift",
  "common.menu.details": "Details",
  "common.menu.deployment": "Einbindungsart",
  "common.buttons.saveOption": "{option} speichern",
  "features.designer.showMenus": "Menüs anzeigen",
  "features.designer.customDesigner.descSubOpeners": "Wählen Sie in der Dropdown-Liste einen Öffnungstyp aus und klicken Sie anschließend in ein Feld oder einen Bereich, um ihn einzufügen. Dadurch können innerhalb größerer Bereiche zusätzliche Öffnungsbereiche definiert werden.",
  "features.costsPrices.labels.baseFramePrice": "Grundpreis Rahmen",
  "features.store.featureAccurateEnquiriesText": "Anfragen, die über {brandedMode} eingehen, basieren auf demselben Regelwerk wie das Bestellsystem von {fabricator}. Dadurch werden Fehler vermieden und Endkunden können keine Anfragen für Produkte erstellen, die nicht gefertigt werden können.",
  "features.customers.unablePaymentWithOrder": "Die Zahlung zusammen mit der Bestellung ist nicht möglich, wenn der SOP-Prozess übersprungen wird.",
  "features.costsPrices.labels.hardware": "Beschläge",
  "common.validation.rules.belowMinimum": "{value} mm liegt {diff} mm unter dem Minimalwert.",
  "features.costsPrices.labels.financialGroups": "Preisgruppen",
  "common.buttons.clearSearch": "Suche löschen",
  "features.basket.overridingJobPriceNote": "Durch das Überschreiben des Preises werden die Preise einzelner Artikel ignoriert.",
  "features.delivery.postCodeAreaMultiple": "Geben Sie eine durch Kommas getrennte Liste von Postleitzahlenbereichen ein.",
  "features.login.resetPasswordTitle": "Passwort zurücksetzen",
  "common.labels.profilePhoto": "Profilbild",
  "common.global.newVersionTitle": "Neue Version verfügbar",
  "common.financial.netSell": "Nettoverkaufspreis",
  "features.costsPrices.labels.tJointAngled": "Abgewinkelte T-Verbindung",
  "features.customers.customerDetails": "Kundendaten",
  "common.menu.slab": "Füllung",
  "common.menu.createQuote": "Angebot erstellen",
  "common.contact.address3": "Adresszeile 3",
  "features.costsPrices.labels.ancillary": "Zusatzoption",
  "features.delivery.address3": "Adresse 3",
  "features.productSettings.fittingCostPerProduct": "Montagekosten / Produkt",
  "features.costsPrices.labels.priceFromCostsPlusMarkup": "Preis aus Kosten + Aufschlag",
  "features.costsPrices.labels.joint": "Verbindung",
  "features.basket.partsList": "Teileliste",
  "features.costsPrices.labels.each": "Jedes",
  "features.customers.unableToSkipSopTitle": "Die Zahlung zusammen mit der Bestellung ist nicht möglich, wenn der SOP-Prozess übersprungen wird.",
  "features.basket.partNumber": "Artikelnummer {code}: {description}",
  "features.costsPrices.warningActivePricingMethods.line1": "Wenn in den obenstehenden Registerkarten bereits aktive Preisermittlungsmethoden vorhanden sind, werden bestehende Preise durch die hier eingegebenen Werte nicht ersetzt. Die Preisermittlungsmethoden wirken gemeinsam. Aktualisieren Sie diesen Bereich und entfernen oder deaktivieren Sie die anderen Methoden, um fehlerhafte Gesamtpreise zu vermeiden.",
  "features.account.showArticle": "Artikel anzeigen",
  "common.status.placedPendingPayment": "Erfasst (Zahlung ausstehend)",
  "features.leadCapture.styling.consumerEmailDescription": "Diese E-Mail informiert den Endkunden darüber, welchem Händler seine Anfrage zugewiesen wurde.",
  "common.datetime.startEndDate": "Start-/Enddatum",
  "common.contact.state": "Bundesland/Provinz",
  "features.designer.selectWhereToApply": "Wählen Sie aus, wo die Änderung angewendet werden soll",
  "common.financial.excVat": "(zzgl. MwSt.)",
  "features.leadCapture.styling.landingPageBackgroundPurpose": "Passen Sie die Landingpage für Kunden an, die {setup} besuchen.",
  "features.basket.perItem": "pro Artikel",
  "features.quotesAndOrders.customerPO": "Kundenbestellung",
  "features.news.savePost": "Nachrichtenbeitrag speichern",
  "features.delivery.postCodeAreaPlaceholder": "Postleitzahlen-Präfix hinzufügen...",
  "features.account.bccEmailAddress": "Bcc-E-Mail-Adresse",
  "features.leadCapture.company.googleAnalytics.step2.part4": "Klicken Sie in den Webstream-Details unten auf „Tag-Einstellungen konfigurieren“.",
  "common.labels.yes": "Ja",
  "features.customers.productDefaults": "Produktstandardwerte",
  "common.datetime.startDate": "Startdatum",
  "features.leadCapture.deployment.option1.tip": "Tipp: Dieser Link kann auch direkt in sozialen Medien geteilt werden, um weitere Anfragen zu generieren",
  "features.styling.tooltip.quotePDFFirstPageImage": "Geben Sie hier den Inhalt ein, der auf der ersten Seite Ihres Angebots-PDFs angezeigt wird.",
  "features.enquiries.enquiryOverdue": "Anfrage überfällig",
  "features.support.manageNews": "News verwalten",
  "features.chooseProduct.chooseGroup": "Gruppe auswählen",
  "features.costsPrices.labels.addExtra": "Zusatzoption hinzufügen",
  "features.costsPrices.labels.opener": "Einleitung",
  "features.productSettings.groups": "Gruppen",
  "common.labels.notRequired": "Nicht erforderlich",
  "features.customers.seePriceBreakdown": "Preisaufschlüsselung anzeigen",
  "features.leadCapture.styling.emailBody": "E‑Mail‑Nachricht",
  "features.basket.extrasTitle": "Produkt-Zusatzoptionen",
  "features.login.processingRequest": "Ihre Kontoanfrage wird bearbeitet. Wir werden uns in Kürze bei Ihnen melden.",
  "features.quotesAndOrders.unlocking": "Entsperre {contractType}",
  "common.buttons.editAddress": "Adresse bearbeiten",
  "features.customers.unableToSkipSopText": "Die Option 'Zahlung mit Bestellung' finden Sie im Abschnitt 'Finanzdaten'.",
  "features.customers.debugCustomer": "Debug-Kunde",
  "features.costsPrices.warningActivePricingMethods.line2": "Dieser Bereich fügt eine weitere Preisermittlungsmethode hinzu. Bereits konfigurierte Preisermittlungsmethoden (z. B. Kosten + Aufschlag aus der Stückliste oder Raster aus der Kosten- bzw. Preisliste) werden nicht ersetzt. Die Methoden wirken gemeinsam und können sich addieren. Wenn diese Methode als einzige Preisquelle verwendet werden soll, nehmen Sie die Anpassungen zuerst hier vor und deaktivieren oder entfernen Sie anschließend die anderen Preisermittlungsmethoden manuell. Andernfalls können in Angeboten und Aufträgen falsche Preise angezeigt werden.",
  "features.staff.noLicensesAllocated": "Es wurden keine Lizenzen zugewiesen.",
  "features.store.branchesTitle": "QUOTILA Filialen",
  "common.buttons.readMore": "Weiterlesen",
  "common.menu.home": "Startseite",
  "features.checkout.orderReviewTitle": "3. Bestellübersicht",
  "features.costsPrices.labels.listCost": "Listenkosten",
  "features.styling.tooltip.emailBodyText": "Geben Sie den Text für die E-Mail ein. Dies kann beispielsweise eine Begrüßung oder die Geschäftsbedingungen für {label} sein.",
  "features.launch.measurementsYesNo": "Haben Sie die Maße?",
  "features.store.consumerWebsiteDescription": "Ein vorgefertigtes Website-Theme von Selecta Systems, das speziell für den Endkundenmarkt entwickelt wurde. Mit 70 vollständig ausgearbeiteten Produktseiten bietet es eine ideale Grundlage für Ihren Online-Auftritt. Zusätzliche Erweiterungen sind verfügbar.",
  "features.quotesAndOrders.noConsumer": "Kein Endkunde",
  "features.quotesAndOrders.cannotDeleteLastJob": "Der letzte Auftrag im Vertrag kann nicht gelöscht werden.",
  "features.enquiries.refusalReason": "Ablehnungsgrund",
  "common.menu.setup": "Einrichtung",
  "common.labels.branch": "Filiale",
  "features.account.searchPlaceholder": "Kunden suchen...",
  "features.basket.addExtras": "Zusatzoptionen hinzufügen",
  "features.account.addressesAndDeliveryDays": "Adressen & Liefertage",
  "features.store.howLeadCaptureSolves": "Wie {brandedMode} dieses Problem löst",
  "features.checkout.pendingPaymentText": "Der Kunde muss sich anmelden und den Auftrag bezahlen.",
  "common.datetime.we": "Mi",
  "features.customers.emailNotFound": "E-Mail nicht gefunden",
  "features.costsPrices.selectPrice": "Wählen Sie {description}-Konfiguration aus",
  "features.costsPrices.labels.baseSashCost": "Grundkosten Flügel",
  "features.paymentGateway.setupIncomplete": "Einrichtung unvollständig",
  "features.leadCapture.hero.inactiveLine3": "{brandedMode}",
  "common.menu.retailOptionControl": "Endkundenoptionen verwalten",
  "features.visualiser.infoMessage": "Klicken Sie zum Start auf das Bild Ihres Fensters oder Ihrer Tür, um es zur Zeichenfläche hinzuzufügen. Ziehen Sie an den Bildecken, um die Größe anzupassen. Klicken Sie auf das Hausbild, um die Größenanpassung zu deaktivieren.",
  "common.labels.basket": "Warenkorb",
  "common.contact.town": "Ort",
  "features.account.deleteThisTaxRate": "Möchten Sie diesen Steuersatz wirklich löschen?",
  "common.buttons.finish": "Fertigstellen",
  "features.basket.unsavedTitleDifferentCustomer": "Im Warenkorb befindet sich ein nicht gespeicherter Eintrag vom Typ {type} für einen anderen Kunden.",
  "features.designer.deleteProductText": "Möchten Sie dieses Produkt wirklich löschen?",
  "features.basket.overrideItemPriceTitle": "Das Überschreiben des Artikelpreises setzt den Auftragspreis zurück.",
  "common.validation.notRecoverable": "Dieser Vorgang kann nicht rückgängig gemacht werden.",
  "common.labels.website": "Website",
  "features.quotesAndOrders.editProducts": "Produkte bearbeiten",
  "common.financial.showFinancials": "Preisdaten anzeigen",
  "features.customers.licensesLabel": "{brandedMode} Lizenzen",
  "features.visualiser.deleteProduct": "Ausgewähltes Produkt löschen",
  "features.kpi.enquiries": "{retail} Anfragen",
  "features.leadCapture.styling.instruction": "Passen Sie Bilder und Texte an, um {touch} an Ihr Unternehmen anzupassen. Sie können verschiedene Bereiche bearbeiten, darunter die Einleitung und den Anfragenbildschirm von {setup}, Virtual Home, PDFs sowie die E-Mail-Kommunikation mit Ihren Kunden.",
  "features.costsPrices.quickPricing": "Legen Sie den Auftragspreis direkt im Angebot fest. Öffnen Sie dazu die Angebotsdetails und klicken Sie auf 'Preis anpassen'. So können Sie einen Auftragspreis festlegen, ohne die erweiterte Preisermittlung vollständig einzurichten.",
  "common.labels.assign": "Zuweisen",
  "features.costsPrices.labels.addGroup": "Gruppe hinzufügen",
  "features.retailOptionsControl.visibleOptions": "Sichtbare Optionen",
  "features.basket.overridePriceTitle": "Überschreiben {price}",
  "features.marketing.confirmDeleteCategory": "Sind Sie sicher, dass Sie diese Kategorie löschen möchten?",
  "features.login.invalidToken": "Ungültiges Token",
  "features.enquiries.upgradeDescription": "Kontaktieren Sie das Vertriebsteam der BM Group, um ein Upgrade auf {retail} durchzuführen.",
  "features.store.featureAccurateEnquiries": "Sie erhalten präzisere Anfragen.",
  "features.login.register": "Konto erstellen",
  "common.global.questionCallUs": "Haben Sie eine Frage? Bitte rufen Sie uns an unter {phoneNumber}",
  "features.checkout.sectionRequired": "Füllen Sie diesen Abschnitt aus, um fortzufahren.",
  "features.paymentGateway.firstDataManaged": "Ihr Zahlungsgateway wird von First Data verwaltet. Es sind keine weiteren Schritte erforderlich.",
  "features.quotesAndOrders.showFinancials": "Preisdaten anzeigen",
  "common.labels.customers": "Kunden",
  "features.costsPrices.labels.unitOfMeasure": "Maßeinheit",
  "features.customers.extruderLimitReachedHtml": "Besuchen Sie Ihr {account}, um Ihr Limit zu erhöhen.",
  "common.contact.line3": "Zeile 3",
  "features.costsPrices.upliftBasePrices": "Grundpreise erhöhen",
  "features.costsPrices.labels.override": "Überschreiben",
  "common.status.notGrouped": "Nicht gruppiert",
  "features.leadCapture.deployment.subHeader": "So richten Sie es ein",
  "common.labels.miles": "Meilen",
  "common.buttons.complete": "Fertigstellen",
  "features.marketing.editFile": "Datei bearbeiten",
  "features.visualiser.referenceImage": "Geben Sie eine Bezeichnung für dieses Bild ein (z. B. Küche, Terrasse).",
  "common.buttons.sending": "Versenden",
  "features.news.contentRequired": "Der Beitrag darf nicht leer sein",
  "features.costsPrices.labels.width": "Breite",
  "features.leadCapture.deployment.copyIframe": "Iframe kopieren",
  "features.account.saveTaxRate": "Steuersatz speichern",
  "common.labels.discount": "Rabatt",
  "common.financial.payNow": "Jetzt bezahlen",
  "features.customers.unablePaymentWithOrderText": "Die Option „SOP überspringen“ finden Sie im Bereich „Unternehmensdetails“.",
  "features.enquiries.lastAssigned": "Zuletzt zugewiesen",
  "features.marketing.allCustomers": "Alle Kunden",
  "features.dashboard.knowledgeBase.articles.title7": "Individuelle Website",
  "common.labels.extras": "Extras",
  "features.costsPrices.labels.supplyMarkup": "Lieferaufschlag",
  "features.store.generatingEnquiriesSolution": "{brandedMode} hebt Sie von der Konkurrenz ab. Integrieren Sie es in Ihre Website oder Social-Media-Kanäle. Es ist ein wirkungsvolles Marketinginstrument, das Kunden die Interaktion mit Ihrem Unternehmen erleichtert.",
  "features.leadCapture.styling.thankYouPageBackgroundPurpose": "Passen Sie den Hintergrund der {setup}-Dankeseite an.",
  "features.designer.customDesigner.tabSubOpeners": "Untergeordnete Öffnungsarten",
  "features.designer.issueInformation": "Informationen",
  "features.enquiries.consumerNotFound": "Der Endkunde wurde nicht gefunden",
  "features.leadCapture.styling.customText": "Benutzerdefinierter Text",
  "features.designer.invalidatedOptionsTitle": "Einige Optionen sind nicht mehr gültig.",
  "features.leadCapture.freeTrial.title": "Kostenlose Testversion der Lead-Erfassung",
  "common.validation.delete": "Möchten Sie {item} wirklich löschen?",
  "features.costsPrices.labels.topRightPrice": "Preis oben rechts",
  "common.buttons.delete": "Löschen",
  "common.status.copyFailed": "Kopieren fehlgeschlagen",
  "features.designer.minimumIs": "{description} Mindestmaß: {min}mm",
  "features.store.professionalPaperwork": "Professionelle Angebots- und Auftragsunterlagen",
  "common.datetime.dateBetween": "Datum {isBetween} {from} {and} {to}",
  "common.validation.validationErrors": "Validierungsfehler",
  "features.quotesAndOrders.orderStatus": "Auftragsstatus",
  "common.status.deleteSuccessful": "Löschvorgang erfolgreich",
  "features.costsPrices.greaterThanOrEqualTo": "<u>{fieldKeyA}</u> muss <strong>größer oder gleich</strong> <u>{fieldKeyB}</u> sein",
  "common.validation.invalidFileType": "Ungültiger Dateityp! Es sind nur PNG- oder JPEG-Dateien zulässig.",
  "features.dashboard.checklist.step4b": "Sie können jetzt mit der Angebotserstellung beginnen.",
  "features.leadCapture.company.gdprDocumentsRequired": "Diese Dokumente sind erforderlich, um die DSGVO-Anforderungen für die Erfassung von Kundendaten über den Modus {setup} zu erfüllen.",
  "features.delivery.postCodeAreaList": "Liste der Postleitzahlenbereiche",
  "features.designer.switchProduct": "Produkt wechseln",
  "common.status.enabled": "Aktiviert",
  "features.costsPrices.labels.warningActivePricingMethods": "Warnung – Aktive Preisermittlungsmethoden",
  "common.global.search": "Suche {item}...",
  "common.menu.availability": "Verfügbarkeit",
  "common.labels.fitter": "Monteur",
  "features.costsPrices.strategy2Step1PerOptionSuffix": "Seiten",
  "features.store.bespokeWebsiteDescription": "Unsere maßgeschneiderten Designs werden individuell auf Ihre Anforderungen abgestimmt, sorgen für einen starken Markenauftritt und bieten ein nahtloses Benutzererlebnis, das die Kundeninteraktion fördert und Ihr Wachstum unterstützt.",
  "features.checkout.pendingPaymentTitle": "Der Auftrag wird mit 'Erfasst (Zahlung ausstehend)' gekennzeichnet.",
  "common.labels.qty": "Anz.",
  "features.marketing.noFileChosen": "Keine Datei ausgewählt",
  "features.leadCapture.freeTrial.redirect": "Sie werden jetzt zu {url} weitergeleitet, um sich für Ihre kostenlose Testversion zu registrieren.",
  "features.quotesAndOrders.noNotes": "Keine Anmerkungen.",
  "common.status.accepted": "Angenommen",
  "common.financial.perMonth": "pro Monat",
  "features.costsPrices.labels.gasFill": "Gasfüllung",
  "features.basket.location": "Standort",
  "features.costsPrices.labels.bottomRightPrice": "Preis unten rechts",
  "common.menu.company": "Unternehmen",
  "features.quotesAndOrders.viewQuote": "Angebot anzeigen",
  "features.quotesAndOrders.onStopTitle": "Kundenstatus – Gesperrt",
  "features.leadCapture.styling.enquiryEmailHeaderImage": "Headerbild für Anfrage-E-Mails",
  "features.account.documentsAndAgreements": "Dokumente & Vereinbarungen",
  "features.costsPrices.labels.surveyCost": "Aufmaßkosten",
  "features.enquiries.noConsumerFound": "Es wurde kein Endkunde gefunden.",
  "common.datetime.wed": "Mittwoch",
  "features.dashboard.knowledgeBase.articles.title3": "{1} wird eingerichtet.",
  "features.visualiser.uploadTip2": "Hohe Qualität und scharf dargestellt.",
  "features.costsPrices.labels.editGrid": "Raster bearbeiten",
  "features.marketing.leadCapturePartnerOnly": "{brandedMode} Nur für Partner",
  "features.delivery.deliveryDays": "Liefertage",
  "features.login.setPasswordHint": "Bitte geben Sie ein Passwort für das Konto ein. Dieses muss mindestens 8 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben sowie eine Ziffer enthalten.",
  "features.enquiries.assignToCustomer": "Anfrage einem Kunden zuweisen",
  "features.store.branchesFeatureInStore": "Bequeme Bestellungen im Store und per Telefon.",
  "features.costsPrices.labels.fanHoles": "Lüftungsöffnungen",
  "features.quotesAndOrders.placedPaymentFailed": "Bestellt (Zahlung fehlgeschlagen)",
  "features.quotesAndOrders.generatingName": "{name} generieren",
  "features.costsPrices.unsavedChangesTitle": "Nicht gespeicherte Änderungen gehen verloren. Möchten Sie fortfahren?",
  "common.buttons.create": "Erstellen",
  "features.account.linkedBranches": "Zugeordnete Filialen",
  "features.login.forgotPassword": "Passwort vergessen? Klicken Sie hier!",
  "common.menu.store": "{touch} Store",
  "features.quotesAndOrders.itemNo": "Artikelnr.",
  "features.productSettings.sourceClearancesTooltip": "Profile mit einem Referenzabstand von <b>{value} mm</b>",
  "common.datetime.hr": "hr",
  "features.store.tradeWebsiteCost": "Einmalige Kosten in Höhe von {price}",
  "common.validation.cornerCostRequired": "Für mindestens einen Eckpreis muss ein Wert angegeben werden.",
  "common.labels.item": "Artikel",
  "common.labels.price": "Preis",
  "features.costsPrices.strategy2Step2LinkLabour": "Arbeitskosten",
  "features.customers.editDiscounts": "Kundenrabatte bearbeiten",
  "features.quotesAndOrders.isLocked": "Dieser {contractType} ist gesperrt.",
  "features.login.createAccount": "Erstellen Sie Ihr Konto",
  "features.launch.launchHeader": "Finden Sie die passenden Produkte für Ihr Zuhause.",
  "common.datetime.dateRange": "Datumsbereich",
  "features.quotesAndOrders.downloadGlassOrder": "Glasbestellung herunterladen",
  "features.designer.invalidatedOptionsText": "Bitte prüfen Sie die folgenden Optionen.",
  "features.quotesAndOrders.placedPaymentSuccessful": "Bestellt (Zahlung erfolgreich)",
  "common.menu.quotes": "Angebote",
  "common.menu.alternateSashOverlaps": "Alternativer Flügelüberschlag",
  "features.costsPrices.labels.grids": "Raster",
  "features.styling.tooltip.metaTitle": "Meta-Tags liefern Suchmaschinen zusätzliche Informationen über eine Seite und werden im Titel des Browser-Tabs angezeigt.",
  "common.labels.trade": "Fachhandel",
  "features.customers.discoverMore": "Mehr erfahren",
  "features.checkout.noDeliveryAddresses": "Keine Lieferadressen verfügbar.",
  "features.paymentGateway.createAccount": "Konto erstellen",
  "common.labels.square": "Quadrat",
  "common.contact.address": "Adresse",
  "common.contact.phone": "Telefon",
  "common.labels.base": "Basis",
  "features.leadCapture.styling.landingPageTitle": "Titel der Landingpage",
  "common.labels.processingLevels": "Bearbeitungsstufen",
  "features.support.exploreKnowledgeBase": "Entdecken Sie die Wissensdatenbank",
  "common.validation.rules.numericMultiple": "Mindestens ein Wert in {field} ist keine Zahl.",
  "features.store.viewDemo": "Demo anzeigen",
  "features.leadCapture.styling.enquiryPdfSummaryFooterDescription": "Die letzte Seite des Anfrage-PDFs im unteren Bereich der Zusammenfassung.",
  "features.designer.optionallyOverride": "Standardwert {value} optional überschreiben",
  "features.quotesAndOrders.fitting": "Montage",
  "features.dashboard.resources": "Medien",
  "common.status.loading": "Wird geladen",
  "features.designer.illustrationDisclaimer": "Die Abbildungen dienen nur zur Veranschaulichung und sind nicht maßstabsgetreu",
  "common.errors.logoNotFound": "[LOGO NICHT GEFUNDEN]",
  "features.account.deleteVoucher": "Möchten Sie den Gutschein {code} wirklich löschen?",
  "common.financial.updatePaymentStatusQuestion": "Möchten Sie den Zahlungsstatus wirklich von <strong>{from}</strong> in <strong>{to}</strong> ändern?<br>Diese Aktion kann nicht rückgängig gemacht werden.",
  "common.global.requiredFileType": "Erforderlicher Dateityp: {fileTypes}",
  "features.leadCapture.company.designA": "Design A",
  "features.costsPrices.labels.fittingCost": "Montagekosten",
  "features.costsPrices.quickSetupImage1Alt": "Preisaufschlüsselung mit Schaltfläche zur Preisanpassung",
  "features.leadCapture.company.googleAnalytics.step4.part1": "Anfrage absenden",
  "features.costsPrices.labels.jointCillWeld": "Fensterbankstoß – geschweißt",
  "common.status.disabled": "Deaktiviert",
  "features.costsPrices.unsavedGridChanges": "Ihre Änderungen in diesem Raster gehen verloren.",
  "features.costsPrices.labels.lists": "Listen",
  "features.designer.customDesigner.windowPreview": "Die Fenstervorschau wird hier angezeigt.",
  "features.costsPrices.labels.colours": "Farben",
  "features.customers.productAvailability": "Produktverfügbarkeit",
  "common.menu.productDefaults": "Standardwerte",
  "features.enquiries.leadCapture.text": "{retail} ermöglicht es Ihnen, eigene Anfragen über Ihre Website, Social-Media-Kanäle und in Ihrem Showroom zu generieren.",
  "common.buttons.selectAll": "Alle auswählen",
  "features.designer.pleaseSelect": "Bitte wählen Sie aus...",
  "features.store.quoteYourCustomer": "Erstellen Sie ein Angebot für Ihren Kunden.",
  "features.styling.labels.quotePDFFirstPageImage": "Bild auf der ersten Angebots‑PDF‑Seite",
  "common.financial.updatePaymentStatus": "Zahlungsstatus aktualisieren",
  "features.customers.confirmDisableBrandedMode": "Sind Sie sicher, dass Sie <strong></strong> {brandedMode} für {name} <u>deaktivieren</u> möchten?",
  "features.costsPrices.greaterThan": "<u>{corner}</u> muss <strong>größer oder gleich</strong> den anderen Ecken sein",
  "common.buttons.select": "Auswählen",
  "features.costsPrices.editPriceFor": "{description} bearbeiten",
  "features.leadCapture.styling.customerEmailReceived": "Geben Sie den E-Mail-Text ein, der an Ihren Kunden gesendet wird, um den Eingang seiner Anfrage zu bestätigen.",
  "common.menu.branch": "Filiale",
  "features.chooseProduct.stageTitle": "STAGE {stage}",
  "features.support.videosIntro": "Hier finden Sie ein paar Videos, die Ihnen den Einstieg erleichtern.",
  "features.store.connectedToPortal": "Verbunden mit {portal}",
  "features.leadCapture.styling.customerEmail": "E-Mail-Bestätigung an den Kunden für eine neue {setup}-Anfrage",
  "features.costsPrices.strategy1Step1Suffix": "und Aufschlagsprozentsätze",
  "features.enquiries.refusalPlaceholder": "Ablehnungsgrund eingeben ...",
  "features.enquiries.details": "Anfragedetails",
  "common.financial.total": "Gesamt",
  "features.leadCapture.deployment.option1.title": "Option 1 – In neuem Fenster anzeigen",
  "features.branches.editBranchDetails": "Filialdetails bearbeiten",
  "common.buttons.expandAll": "Alle erweitern",
  "features.staff.unlimited": "unbegrenzt",
  "common.status.failed": "Fehlgeschlagen",
  "features.costsPrices.labels.jointTAngledMech": "Abgewinkelte T-Verbindung – mechanisch",
  "features.branches.setPrimary": "Als Standard festlegen",
  "common.status.notSent": "Nicht gesendet",
  "features.paymentGateway.finishStripeSetup": "Einrichtung von Stripe abschließen",
  "features.dashboard.knowledgeBase.store": "{touch} Store",
  "features.visualiser.addItemPrompt": "Um ein Produkt zu visualisieren, fügen Sie den Artikel dem {basket} hinzu.",
  "features.costsPrices.wastageTooltip": "Der eingegebene Wert wirkt sich auf den für alle Stücklistenpositionen berechneten Verschnitt aus.",
  "features.account.customersLimitedTo": "Kunden beschränkt auf",
  "features.costsPrices.labels.simulateCostMatrix": "Kostenmatrix simulieren",
  "features.store.tabClosingASale": "Abschluss eines Verkaufs",
  "features.costsPrices.widthIncrement": "Breitenschritt",
  "features.costsPrices.labels.jointCornerSquareWeld": "Rechtwinklige Eckverbindung – geschweißt",
  "common.menu.staff": "Mitarbeiter",
  "features.checkout.actionRequiredTitle": "Aktion erforderlich",
  "features.quotesAndOrders.cancelOrderRiskText": "Mir ist bewusst, dass eine stornierte Bestellung nicht wiederhergestellt werden kann. Ich möchte die Stornierung fortsetzen.",
  "common.buttons.edit": "Bearbeiten",
  "features.leadCapture.company.googleAnalytics.setup": "Richten Sie Analytics ein, um Traffic & Conversions in {setup} zu messen.",
  "features.account.applyTax": "Steuer anwenden",
  "features.login.title": "Willkommen zurück!",
  "features.basket.customerCurrencyLabel": "Kundenwährung ({code})",
  "features.basket.sizingWarningInstructions": "Sobald Sie die tatsächlichen Maße für <strong>alle Produkte</strong> eingegeben haben, klicken Sie auf die Schaltfläche unten, um diesen Hinweis auszublenden.",
  "features.costsPrices.labels.cruciformJoint": "Kreuzstoß",
  "features.designer.editMeasurements": "Maße bearbeiten",
  "common.global.imageRatioRequired": "Erforderliches Seitenverhältnis: 4:3 (z. B. 400 × 300 oder 1200 × 900).",
  "features.quotesAndOrders.saveRetryWait": "Bitte warten Sie {minutes} {unit}, bevor Sie erneut versuchen, diesen Auftrag zu speichern.",
  "features.quotesAndOrders.searchPlaceholder": "Nach Referenz suchen ...",
  "features.quotesAndOrders.priceManuallyUpdated": "Der Preis eines Artikels wurde manuell aktualisiert.",
  "features.store.leadCaptureHeading": "{name} - {price} {perMonth}",
  "features.costsPrices.labels.upliftSelected": "Auswahl mit Aufschlag versehen",
  "common.validation.noResults": "Keine Ergebnisse gefunden",
  "common.errors.submitFeedback": "Feedback senden",
  "common.global.recommendedImageSize": "Empfohlene Größe: {width}px × {height}px",
  "features.visualiser.uploadHomeDesc": "Sie können mehrere Bilder hochladen, z. B. Vorder-, Rück- und Seitenansichten.",
  "common.labels.date": "Datum",
  "common.validation.rules.maxPostCodePrefixLength": "Maximal 4 Buchstaben im Postleitzahlenpräfix",
  "features.designer.internalExternalView": "Interne/Externe Ansicht",
  "common.financial.tax": "Steuer",
  "features.paymentGateway.refreshAfterChanges": "Aktualisieren Sie die Seite nach vorgenommenen Änderungen.",
  "common.financial.paymentSuccessful": "Zahlung erfolgreich",
  "common.buttons.reorder": "Neu anordnen",
  "features.customers.skipPendingOrderCustomer": "Ausstehenden Auftrag überspringen (Kunde)",
  "features.delivery.editDeliveryDays": "Liefertage bearbeiten",
  "features.store.enquireNow": "Jetzt anfragen",
  "features.basket.makeEnquiry": "Anfrage stellen",
  "features.basket.applyVoucher": "Übernehmen",
  "features.enquiries.selfGenerated": "Selbst erstellt",
  "common.buttons.cancel": "Abbrechen",
  "features.leadCapture.styling.landingPageIntro": "Einleitung der Landingpage",
  "features.costsPrices.labels.topLeftPrice": "Preis oben links",
  "features.login.emailValidated": "Vielen Dank, dass Sie Ihre E-Mail-Adresse bestätigt haben.",
  "common.buttons.discard": "Verwerfen",
  "features.costsPrices.labels.addNewGroup": "Neue Gruppe hinzufügen",
  "common.labels.salesSector": "Vertriebsbereich",
  "features.quotesAndOrders.reportsNotAvailableForOldJobs": "Diese Funktion ist für Aufträge verfügbar, die nach dem {date} verarbeitet wurden.",
  "features.costsPrices.costMarkupTooltip": "Der eingegebene Wert wird nur bei der Preisermittlung nach Kostenaufschlag berücksichtigt. ",
  "features.designer.yesDeleteProduct": "Ja, und löschen Sie mein aktuelles Produkt",
  "features.marketing.noDocumentsMatch": "Keine Dokumente für {search} gefunden.",
  "features.designer.customDesigner.stepOf": "Schritt {current} von {total}",
  "common.labels.currency": "Währung",
  "common.datetime.tues": "Di",
  "features.costsPrices.labels.sashOverlap": "Flügelüberstand",
  "features.store.branchesFeatureFlexible": "Flexibler eigenständiger Betrieb",
  "features.costsPrices.labels.jointCruciformMech": "Kreuzverbindung – mechanisch",
  "features.quotesAndOrders.margin": "Marge",
  "common.status.on": "Auf",
  "features.costsPrices.setupPricingDescription": "Wählen Sie zwischen der Schnellkalkulation für einfache Aufträge und der erweiterten Preisermittlung für eine genaue positionsbasierte Preisberechnung.",
  "features.leadCapture.company.showDesignNames": "Designnamen anzeigen",
  "common.datetime.time": "Zeit",
  "features.switchDesign.selectDesign": "Wählen Sie ein {name} Design aus.",
  "features.kpi.ordered": "Bestellt",
  "features.kpi.quotesCreated": "Erstellte Angebote",
  "features.quotesAndOrders.quoteCustomerSubtext": "Geben Sie unten Ihren Verkaufspreis ein, um ein Kundenangebot zu erstellen.",
  "features.account.voucherOutOf": "{current} von {total}",
  "common.labels.currentOfTotal": "{current} von {total}",
  "features.leadCapture.deployment.howToDeploy": "So richten Sie {setup} ein",
  "features.store.professionalPaperworkDesc": "Professionelle Angebotsunterlagen für Ihren Markenauftritt.",
  "features.chooseProduct.selectGroup": "Gruppe auswählen",
  "features.dashboard.knowledgeBase.articles.title8": "{2}",
  "features.costsPrices.partialSave": "Zwischenspeichern",
  "common.buttons.sync": "Synchronisieren",
  "common.labels.number": "Nummer",
  "features.leadCapture.company.googleAnalytics.step2.part8": "Wiederholen Sie Schritt 6 und geben Sie als Domain für den Designer bm-touch.co.uk ein.",
  "features.delivery.postCodeAreas": "Postleitzahlenbereiche",
  "features.costsPrices.labels.itemCode": "Artikelcode",
  "common.validation.addressAlreadyExists": "Diese Adresse ist für diesen Kunden bereits vorhanden.",
  "features.basket.addItem": "Artikel hinzufügen",
  "features.store.featureOwnSystemText": "Individuell entwickelte Software zur Leadgenerierung kann schnell Kosten von rund {price} verursachen. Die Erstellung präziser Daten und Regelwerke für Produktoptionen ist zeitaufwendig und kostspielig. Mit {brandedMode} haben wir diese Arbeit bereits für Sie erledigt. Sie erhalten eine kostengünstige Lösung mit zahlreichen Vorteilen.",
  "features.kpi.enquiriesTitle": "Anfragen",
  "features.login.cta": "Anmelden",
  "common.validation.areYouSure": "Sind Sie sicher?",
  "features.designer.customDesigner.invalidShape": "Ungültige Form",
  "common.financial.poa": "PAA",
  "features.costsPrices.labels.unit": "Einheit",
  "features.paymentGateway.noStripeAccountFound": "Es wurde kein Stripe-Konto gefunden",
  "common.menu.resourceCentre": "Medienbibliothek",
  "features.quotesAndOrders.colourInternal": "Farbe (intern)",
  "features.costsPrices.tooManyMatrixSteps": "Erhöhen Sie den Schrittwert, um die Anzahl der Schritte in der Matrixansicht zu reduzieren. Aktuelle Anzahl: {current}, maximal zulässig: {max}.",
  "features.leadCapture.styling.customerEmailAssignment": "Geben Sie den E-Mail-Text ein, der an Ihren Kunden gesendet wird, um zu bestätigen, dass ihm im Portal eine {setup}-Anfrage zugewiesen wurde.",
  "features.login.setPasswordTitle": "Passwort festlegen",
  "features.quotesAndOrders.expiryStatus": "Ablaufstatus",
  "common.menu.branches": "Filialen",
  "features.costsPrices.labels.advancedPricing": "Erweiterte Preisgestaltung",
  "features.designer.noExtrasSelected": "Keine Zusatzoptionen ausgewählt",
  "common.global.termsAndConditions": "Terms & Conditions",
  "features.costsPrices.labels.perimeter": "Umfang",
  "common.errors.pageNotFound": "Seite nicht gefunden.",
  "features.store.consumerWebsiteTheme": "Design der Endkunden-Website",
  "features.enquiries.assignToCustomerConfirm": "Sind Sie sicher, dass Sie diesem Kunden eine Anfrage zuweisen möchten?",
  "features.store.beOnlineInMinutes": "In wenigen Minuten online",
  "features.styling.tooltip.loginHeader": "Geben Sie hier die Überschrift für die Anmeldeseite Ihres {touch}-Portals ein.",
  "features.marketing.pleaseAddVideoUrl": "Bitte fügen Sie eine Video-URL hinzu",
  "features.basket.getAQuote": "Angebot anfordern",
  "features.account.activeCustomerPeriod": "Aktive Kundenlaufzeit",
  "features.costsPrices.labels.jointTSquareWeld": "Rechtwinklige T-Verbindung – geschweißt",
  "features.basket.overridingQuantityNote": "Der eingegebene Wert wird durch die Artikelmenge geteilt.",
  "common.menu.requoteMarkups": "Aufschläge neu berechnen",
  "features.login.customerEmail": "Kunden-E-Mail",
  "features.designer.dimensionRange": "{min}mm – {max}mm",
  "features.costsPrices.labels.glazing": "Verglasung",
  "common.validation.unSavedChangesQuery": "Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen, ohne zu speichern?",
  "features.account.applyTaxToRequotes": "Steuer auf Neuangebote anwenden",
  "common.menu.brandedMode": "{brandedMode}",
  "common.buttons.remove": "Entfernen",
  "features.costsPrices.labels.minHeight": "Minimale Höhe",
  "common.contact.postcode": "Postleitzahl",
  "features.delivery.noDeliveryDaysSelected": "Es wurden keine Liefertage ausgewählt.",
  "features.login.password": "Passwort",
  "features.costsPrices.labels.addOptions": "Optionen hinzufügen",
  "features.costsPrices.labels.decorativeGlassDesign": "Dekorglas-Design",
  "features.store.featureQuoteManagement": "Angebotsverwaltung",
  "features.customers.extruderFeatureCustomPricing": "Individuelle Preisgestaltung",
  "features.delivery.deliveryType": "Lieferart",
  "features.costsPrices.labels.jointTSquareMech": "Rechtwinklige T-Verbindung – mechanisch",
  "features.costsPrices.labels.perMeter": "pro Meter",
  "features.switchDesign.noProductsMatch": "Keine passenden Produkte für {search} gefunden.",
  "features.quotesAndOrders.quoteStatus": "Angebotsstatus",
  "features.costsPrices.labels.jointCillMech": "Fensterbankstoß – mechanisch",
  "features.enquiries.assigned": "Zugewiesen",
  "common.labels.code": "Code",
  "features.customers.saveCustomer": "Kunde speichern",
  "features.costsPrices.strategy1Step3": "{labour}-Kosten hinzufügen und Finanzkategorien zuweisen",
  "features.basket.saveUnavailableTitle": "Speichern nicht verfügbar",
  "features.kpi.quoted": "Angeboten",
  "features.account.deliveryTitle": "Lieferadressen & Liefertage",
  "features.marketing.visibleTo": "Sichtbar für?",
  "features.store.closingSaleSolution": "Nutzen Sie {brandedMode}, um Kunden mit hochwertigen, präzisen Produktdarstellungen und professionellen Angebotsunterlagen zu begeistern. Mit dem Virtual Home Visualiser können Ihre Kunden sogar sehen, wie die Produkte an ihrem eigenen Zuhause aussehen werden.",
  "features.styling.labels.loginPageBackgroundImage": "Hintergrundbild der Anmeldeseite",
  "features.costsPrices.labels.general": "Allgemein",
  "common.menu.glass": "Glas",
  "features.leadCapture.company.thankYouPageRedirectText": "Legen Sie eine benutzerdefinierte URL fest, zu der Kunden nach dem Absenden des Anfrageformulars im {setup}-Modus weitergeleitet werden.",
  "features.costsPrices.labels.maxWidthShort": "Maximale Breite",
  "features.costsPrices.labels.bottomRight": "Unten rechts",
  "common.status.unknown": "Unbekannt",
  "features.quotesAndOrders.supplyAndFit": "Lieferung & Montage",
  "common.labels.admin": "Admin",
  "features.marketing.openExternalLink": "Sie sind dabei, einen externen Dateilink zu öffnen.",
  "features.costsPrices.strategy2Title": "Strategie 2: Direkte Preisangabe",
  "features.costsPrices.labels.beading": "Glasleiste",
  "common.buttons.back": "Zurück",
  "features.designer.noSelection": "Keine Auswahl",
  "features.designer.maxLengthError": "{label} muss aus höchstens {maxLength} Zeichen bestehen.",
  "common.buttons.ok": "Ok",
  "common.buttons.addAddress": "Adresse hinzufügen",
  "features.marketing.unsupportedVideoUrl": "Wir unterstützen ausschließlich YouTube- oder Vimeo-URLs.",
  "features.basket.viewBasket": "Warenkorb anzeigen",
  "features.productSettings.disabledHint": "Diese Option kann in der Konfiguration nicht eingerichtet werden und ist derzeit nicht aktiv.",
  "features.designer.showXView": "{label} -Ansicht anzeigen",
  "features.basket.unsavedTitle": "Im Warenkorb befindet sich ein nicht gespeicherter Eintrag vom Typ {type}.",
  "common.menu.account": "Konto",
  "features.designer.viewOptions": "Anzeigeoptionen",
  "features.designer.finishDesigning": "Entwurf abschließen",
  "features.basket.voucherAlreadyAppliedText": "Möchten Sie diesen Code wirklich überschreiben?",
  "features.costsPrices.labels.weld": "Schweißen",
  "features.dashboard.knowledgeBase.articles.title4": "Steigern Sie Ihren Umsatz mit {1}",
  "features.costsPrices.labels.mech": "Mech",
  "features.customers.activeRate": "Anteil aktiver Kunden",
  "features.designer.customDesigner.descOpeners": "Wählen Sie einen Öffnungstyp aus der Dropdown-Liste und klicken Sie anschließend auf ein Feld im Raster, um ihn anzuwenden. Wiederholen Sie den Vorgang mit weiteren Öffnungstypen, bis alle benötigten Öffnungen festgelegt sind.",
  "features.customers.paymentsSetupRequired": "Einrichtung der Zahlungsabwicklung erforderlich.",
  "features.basket.backToBasket": "Zurück zum Warenkorb",
  "common.labels.previewChanges": "Vorschau der Änderungen",
  "features.leadCapture.styling.FooterTitle": "Fußzeilentitel",
  "features.designer.customDesigner.descTransomsMullions": "Wählen Sie durch Klicken auf eine horizontale oder vertikale Linie aus, wo Sie Riegel oder Pfosten hinzufügen möchten. Fügen Sie so viele hinzu, wie Sie für Ihre Konstruktion benötigen.",
  "features.customers.noLicensesAllocated": "Es wurden keine Lizenzen zugewiesen.",
  "features.account.voucherNote": "Bitte beachten: <b>Gutscheine gelten auf Auftragsebene.</b>",
  "features.chooseProduct.noProductsAvailable": "Keine Produkte verfügbar",
  "features.costsPrices.strategy1Step1LinkFinancialCategories": "Preiskategorien",
  "features.marketing.addNewVideo": "Neues Video hinzufügen",
  "features.customers.searchHeadings": "Überschriften durchsuchen...",
  "common.labels.createdAt": "Erstellt am",
  "common.labels.alias": "Kurzname",
  "features.chooseProduct.noCategoriesFound": "Keine Kategorien gefunden",
  "features.designer.noSpecsFoundTextCallUs": "Bitte rufen Sie unter <a href=\"tel:{phone}\" class=\"underline\">{phone}</a> an, um die Spezifikationen für dieses Produkt festzulegen, bevor Sie fortfahren.",
  "features.account.workingDays": "Arbeitstage",
  "features.costsPrices.unsavedListChanges": "Ihre Änderungen an dieser Liste gehen verloren.",
  "common.global.maxFileSize": "Maximale Dateigröße: {mb} MB",
  "features.customers.confirmUpdateExpiryDate": "Möchten Sie das Ablaufdatum für {name} auf <strong><u>{date}</u></strong> wirklich aktualisieren?",
  "features.quotesAndOrders.accountNotActiveTitle": "Dieses Konto ist nicht aktiv. Bitte wenden Sie sich an Ihren Hersteller.",
  "features.marketing.searchPlaceholder": "Marketingmaterialien durchsuchen ...",
  "common.menu.processingOptions": "Verarbeitungsoptionen",
  "features.costsPrices.labels.fittingMarkup": "Montageaufschlag",
  "common.labels.options": "Optionen",
  "common.menu.customerManagement": "Kundenverwaltung",
  "features.productSettings.availableInLeadCapture": "In der Lead-Erfassung verfügbar",
  "features.costsPrices.labels.markup": "Aufschlag",
  "features.leadCapture.hero.inactiveLine1": "Nicht verpassen!",
  "features.dashboard.checklist.step2": "2. Fügen Sie Ihre Teammitglieder hinzu",
  "features.productSettings.mainDefault": "Standard-Hauptansicht",
  "features.customers.setExpiryDate": "Ablaufdatum festlegen",
  "features.store.theProblem": "Das Problem",
  "features.costsPrices.strategy1Step3Prefix": "Hinzufügen",
  "features.leadCapture.setup.activateProductsTextBusiness": "Aktivieren Sie die Produkte für {setup}. Dabei sollte es sich um Produkte handeln, zu denen Endkunden Anfragen stellen können.",
  "features.store.visualiserDescription": "Im Gegensatz zu herkömmlichen Visualisierungsprogrammen können Hausbesitzer mit dem QUOTILA Visualiser Bilder aller Fassaden ihrer Immobilie hochladen, sowohl innen als auch außen.",
  "features.quotesAndOrders.backDoNotCancel": "Zurück (nicht abbrechen)",
  "features.costsPrices.labels.patterns": "Muster",
  "features.basket.addDimensionsRequired": "Sie müssen Maße hinzufügen",
  "features.leadCapture.styling.enquiryEmailHeaderImageLocation": "Bereich: Kopfzeile der E-Mail-Bestätigung, die der Benutzer nach dem Absenden einer Anfrage erhält.",
  "features.account.editFinancialDetails": "Finanzdaten bearbeiten",
  "features.leadCapture.hero.expiringLine4": "Läuft bald ab",
  "features.account.chooseCurrency": "Währung auswählen",
  "common.labels.value": "Wert",
  "features.quotesAndOrders.subtotalManuallyUpdated": "Die Zwischensumme wurde manuell geändert.",
  "features.account.fixed": "Festpreis",
  "features.quotesAndOrders.newQuote": "Neues Angebot",
  "features.store.viewPortfolio": "Portfolio anzeigen",
  "features.costsPrices.selectMultipleBy": "Mehrfachauswahl nach",
  "common.menu.customers": "Kunden",
  "features.news.categoryRequired": "Bitte wählen Sie eine Kategorie aus",
  "common.datetime.hrs": "Std.",
  "features.quotesAndOrders.refreshContract": "Aktualisiere {contractType}",
  "common.status.mandatory": "Obligatorisch",
  "common.global.branding": "Von {brandName}",
  "features.costsPrices.advancedPricing.line2": "Auch nach der Einrichtung der erweiterten Preisermittlung können Preise weiterhin über die Funktion 'Preis anpassen' für die Schnellkalkulation überschrieben werden.",
  "features.styling.labels.loginHeader": "Anmeldeüberschrift",
  "features.basket.supplyOnly": "Nur Lieferung",
  "features.staff.resendActivation": "Der Benutzer muss gespeichert werden, bevor die Aktivierungs-E-Mail erneut gesendet werden kann.",
  "common.buttons.continue": "Weiter",
  "features.launch.noHint": "Wenn Sie lediglich einen Entwurf erstellen und eine Anfrage stellen möchten, klicken Sie auf {button}.",
  "features.paymentGateway.manageStripeAccountLink": "Folgen Sie dem Link, um Ihr Stripe-Konto zu verwalten.",
  "features.costsPrices.labels.copyProductTo": "${productName} kopieren nach...",
  "common.buttons.reload": "Neu laden",
  "features.marketing.pleaseChooseVideoCategory": "Bitte wählen Sie eine Videokategorie aus",
  "common.datetime.tu": "Di",
  "common.contact.city": "Ort",
  "features.productSettings.pendingHint": "Diese Option kann konfiguriert werden, ist jedoch noch nicht aktiv.",
  "features.store.mustUsePortal": "{fabricator} muss {portal} verwenden",
  "common.menu.leadTimes": "Lieferzeiten",
  "common.status.saveSuccessful": "Speichern erfolgreich",
  "features.news.summaryRequired": "Bitte verfassen Sie eine Zusammenfassung für diesen Beitrag.",
  "features.leadCapture.products.availableInLeadCapture": "In der Lead-Erfassung verfügbar",
  "common.labels.surveySheet": "Aufmaßblatt",
  "features.customers.registrationRequests": "Registrierungsanfragen",
  "features.leadCapture.company.googleAnalytics.step3.header": "Prüfen Sie, ob domänenübergreifende Messungen funktionieren.",
  "features.leadCapture.setup.requiredSetup": "* Systemvoraussetzungen",
  "features.quotesAndOrders.bodyText": "Fließtext",
  "features.leadCapture.deployment.option2.step2": "2) Fügen Sie den Code in einen Container an der Stelle ein, an der er auf Ihrer Website angezeigt werden soll.",
  "features.costsPrices.labels.aperture": "Öffnung",
  "features.costsPrices.strategy2Step1PerPartPrefix": "Preise pro Teil hinzufügen in",
  "common.labels.filterBy": "Filtern nach",
  "features.costsPrices.labels.doorDesigns": "Türdesigns",
  "features.quotesAndOrders.clickToAddDetails": "Klicken Sie hier, um Details hinzuzufügen",
  "features.basket.qtyInvalid": "Die Menge muss größer als null sein.",
  "features.basket.voucherApplied": "Gutscheincode angewendet",
  "common.status.awaiting": "Warten",
  "features.launch.measurementsAvailable": "Ich habe Bemaßungswerte",
  "features.chooseProduct.partNo": "Artikelnummer",
  "features.costsPrices.labels.length": "Länge",
  "features.login.requestReceived": "Vielen Dank für Ihre Anfrage.",
  "features.leadCapture.deployment.option2.title": "Option 2 – In iFrame anzeigen",
  "features.costsPrices.labels.otherCorners": "Weitere Ecken",
  "features.costsPrices.labels.globalPrice": "Gesamtpreis",
  "features.marketing.pleaseChooseCategory": "Bitte wählen Sie eine Dokumentkategorie aus.",
  "features.account.voucherUses": "Nutzung",
  "common.menu.emails": "E-Mails",
  "features.customers.brandedModePromoCall": "Für weitere Informationen wenden Sie sich bitte telefonisch an unser Vertriebsteam unter {phone}",
  "features.login.step3": "Warten auf Genehmigung",
  "features.account.fittingCostJob": "Montagekosten / Auftrag",
  "features.costsPrices.labels.possibleCombinedPricing": "Mögliche Preiskombinationen",
  "common.status.off": "Aus",
  "features.news.imageRequired": "Bitte wählen Sie ein Bild aus",
  "features.costsPrices.labels.backingGlass": "Dekorglas",
  "common.labels.is": "ist",
  "features.login.resetPasswordSubtitle": "Geben Sie ein neues Passwort ein.",
  "features.customers.extruderLevelIs": "Extruder Level {is} {status}",
  "common.menu.specifications": "Katalogspezifikationen",
  "features.customers.customerLicenses": "Kundenlizenzen",
  "common.buttons.import": "Importieren",
  "common.labels.squares": "Quadrate",
  "features.basket.editExtras": "Zusatzoptionen bearbeiten",
  "features.account.editCompanyDetails": "Unternehmensdaten bearbeiten",
  "features.costsPrices.labels.cornerJointSquare": "Rechtwinklige Eckverbindung",
  "common.menu.placedOrders": "Erfasste Aufträge",
  "features.staff.licenseLimitAccount": "Konto",
  "common.menu.panel": "Paneel",
  "features.leadCapture.hero.activeList1": "So generieren Sie Anfragen",
  "features.visualiser.uploadTips": "Tipps zum Hochladen",
  "common.buttons.prev": "Zurück",
  "features.costsPrices.labels.jointButtMech": "Stumpfstoß – mechanisch",
  "features.costsPrices.labels.quickPricing": "Schnellkalkulation",
  "features.productSettings.currentDefault": "Aktuelle Standardeinstellung",
  "features.basket.noExtrasSelected": "Keine Zusatzoptionen ausgewählt",
  "features.leadCapture.deployment.gdpr": "Laden Sie Ihre DSGVO-Dokumente hoch. Anschließend können Sie Ihren Designer einrichten.",
  "features.leadCapture.setup.businessDocumentsTextPortal": "Zur Einhaltung der DSGVO müssen Nutzungsbedingungen und eine Datenschutzerklärung bereitgestellt werden.",
  "features.retailOptionsControl.optionItems": "Optionen",
  "features.quotesAndOrders.downloadMultisegmentWorksOrder": "Multisegment-Arbeitsauftrag herunterladen",
  "features.basket.orderOnHoldTitle": "Auftrag zurückgestellt",
  "features.basket.deleteItem": "Artikel löschen",
  "features.costsPrices.strategy1Description": "Ermitteln Sie Preise automatisch anhand Ihrer Kosten und Aufschlagsprozentsätze.",
  "features.designer.fullScreenImage": "Vollbildansicht",
  "common.financial.vat": "Mehrwertsteuer",
  "features.quotesAndOrders.requoteCustomer": "Neues Angebot für Kunden",
  "features.account.addHoliday": "Feiertag hinzufügen",
  "features.visualiser.noItems": "Keine Artikel in „{basket}“.",
  "features.leadCapture.setup.manageDetails": "Details verwalten",
  "features.delivery.deliveryNotes": "Lieferhinweise",
  "features.leadCapture.company.enquiryOverdueLimitText": "Legen Sie fest, wie lange ein Kunde für die Bearbeitung einer {setup}-Anfrage Zeit hat. Geben Sie die Anzahl der Stunden an. Wird die Anfrage innerhalb dieses Zeitraums nicht bearbeitet, kann sie einem anderen Kunden zugewiesen werden.",
  "features.basket.leaveTitle": "Möchten Sie die Seite wirklich verlassen?",
  "features.quotesAndOrders.confirmDeleteJob": "Möchten Sie diesen Auftrag wirklich löschen?",
  "common.menu.analytics": "Analytics",
  "common.validation.saveChanges": "Änderungen speichern?",
  "features.designer.notMadeRequiredSelections": "Sie haben nicht alle erforderlichen Auswahlkriterien festgelegt.",
  "features.basket.overrideJobPriceTitle": "Das Überschreiben des Auftragspreises setzt alle Artikelpreise zurück.",
  "features.marketing.pleaseChooseFile": "Bitte wählen Sie eine Datei aus oder fügen Sie eine Datei-URL hinzu.",
  "features.leadCapture.hero.activeList3": "Ideen für Social-Media-Beiträge",
  "features.checkout.deliveryAddressSection": "1. Lieferadresse",
  "common.validation.rules.max": "{field} darf {max} nicht überschreiten",
  "features.styling.labels.requoteEmail": "{label} E-Mails",
  "features.launch.measurementsNotAvailable": "Ich habe keine Maße.",
  "features.customers.extruderLevel": "Extruder Level",
  "features.costsPrices.labels.fixed": "Festpreis",
  "features.leadCapture.company.googleAnalytics.step2.part7": "Geben Sie die Domain Ihrer Website ein, z. B. example.com (ohne https)",
  "common.errors.somethingWrong": "Hoppla! Da ist etwas schiefgelaufen...",
  "features.account.sendBccEmail": "Bcc-E-Mail senden",
  "features.support.introTitle": "Einleitung",
  "common.labels.licenseStatus": "Lizenzstatus",
  "common.validation.unSavedChanges": "Es liegen ungespeicherte Änderungen vor",
  "features.store.datedBrochuresSolution": "{brandedMode} ist jederzeit aktuell und präzise und lässt sich auf jedem Tablet oder Laptop einfach präsentieren.",
  "features.account.disablePortalProcessingWarning": "Durch Aktivieren dieser Einstellung wird die Verarbeitung für alle Portalbenutzer deaktiviert.",
  "features.costsPrices.labels.minWidthShort": "Mindestbreite",
  "features.costsPrices.labels.optionName": "Optionsname",
  "common.menu.products": "Produkte",
  "features.news.content": "Inhalt",
  "features.store.leadCaptureDescription": "{brandedMode} ist Ihre Lösung zur Kundengewinnung für den Einsatz online, im Ausstellungsraum oder direkt beim Kunden vor Ort. Die Anwendung ist mit dem Bestellportal Ihres Herstellers verbunden.",
  "features.retailOptionsControl.tooltips.productsFilter.line1": "Filtern Sie die Optionen für ein bestimmtes Produkt.",
  "features.leadCapture.styling.landingPageBodyText": "Haupttext der Landingpage",
  "features.account.approveOrdersWithWarnings": "Aufträge trotz Warnungen genehmigen",
  "features.costsPrices.labels.uplift": "Aufschlag",
  "features.customers.noTaxRatesAvailable": "Es liegen keine Steuersätze vor",
  "features.quotesAndOrders.lockedByUser": "Dieser Auftrag ist durch Sie gesperrt.",
  "features.costsPrices.strategy2Step1PerPartLink": "Teileliste",
  "features.delivery.enterAddressManually": "Adresse manuell eingeben",
  "features.leadCapture.deployment.option2.notRecommended": "Nicht empfohlen bei Verwendung von Google Analytics.",
  "features.store.featureAccurateProductImagery": "Präzise Produktdarstellungen",
  "features.costsPrices.quickSetupImage2Alt": "Klicken Sie auf 'Preis anpassen', um einen neuen Preis einzugeben.",
  "features.visualiser.rotateDevice": "Drehen Sie Ihr Gerät für eine optimale Darstellung.",
  "features.styling.tooltip.loginBodyText": "Geben Sie hier den Begrüßungstext ein, der auf Ihrer Portalanmeldeseite unter den Überschriften angezeigt wird.",
  "features.enquiries.assignToNameConfirm": "Sind Sie sicher, dass Sie eine Anfrage an {name} zuweisen möchten?",
  "features.costsPrices.labels.topLeftCost": "Kosten oben links",
  "features.leadCapture.company.noAddresses": "Sie haben keine gespeicherten Adressen.",
  "features.basket.consentNonDealer": "Aktivieren Sie das Kontrollkästchen, um zu bestätigen, dass die von Ihnen angegebenen Informationen an uns übermittelt werden dürfen. Wir werden uns mit Ihnen in Verbindung setzen, um Ihre Anfrage zu besprechen.",
  "features.kpi.quotes": "Angebote",
  "common.validation.rules.email": "{field} muss eine gültige E-Mail-Adresse sein",
  "features.enquiries.searchPlaceholder": "Nach Anfrage suchen ...",
  "common.buttons.revert": "Zurücksetzen",
  "common.menu.chooseProduct": "Produkt auswählen",
  "features.leadCapture.styling.virtualHomeBackgroundPurpose": "Personalisieren Sie den Hintergrund für Virtual Home",
  "common.menu.partsList": "Teileliste",
  "features.costsPrices.labels.area": "Fläche",
  "features.quotesAndOrders.downloadWorksOrder": "Auftrag herunterladen",
  "features.costsPrices.labels.types": "Typen",
  "features.costsPrices.strategy2Step1PerOption": "Hinterlegen Sie Preise je Option auf den Seiten {product}, {glass}, {panel} und {slab}.",
  "features.customers.showPriceBreakdown": "Preisaufschlüsselung anzeigen",
  "features.store.tabGeneratingEnquiries": "Anfragen generieren",
  "features.login.step4": "Anmelden, um Angebote zu erstellen & Bestellungen aufzugeben",
  "features.costsPrices.labels.doorGlass": "Türverglasung",
  "features.launch.tradeCustomerLink": "Hier klicken für Angebote & Bestellungen",
  "features.enquiries.dealerText": "Generieren Sie Endkundenanfragen, die Sie an Ihre Händler weiterleiten können.",
  "features.designer.noFilter": "Kein Filter",
  "features.leadCapture.hero.expiringLine1": "Ihr Hersteller",
  "common.labels.accountEnabled": "Konto aktiviert",
  "features.quotesAndOrders.internalNotes": "Interne Notizen",
  "features.leadCapture.deployment.aliasTooltip": "Geben Sie die URL bzw. Webadresse für Ihr {setup} an. In der Regel wird hierfür Ihr Unternehmensname verwendet.",
  "common.buttons.emailSent": "E-Mail gesendet",
  "common.datetime.minutes": "Minuten",
  "features.costsPrices.strategy1Step2PerOptionPrefix": "Kosten je Option hinzufügen und Preiskategorien zuweisen in",
  "common.datetime.thurs": "Do",
  "features.productSettings.fittingCostPerChildProduct": "Montagekosten / Teilprodukt",
  "features.productSettings.enabledHint": "Diese Option kann konfiguriert werden und ist aktiv.",
  "features.account.amount": "Betrag",
  "features.chooseProduct.allDesignsViewedFromOutside": "Alle Designs in der Außenansicht",
  "common.menu.vouchers": "Gutscheine",
  "features.leadCapture.company.rejectedEnquiries": "An diese E‑Mail-Adresse senden wir Details zu allen abgelehnten Anfragen.",
  "common.menu.settings": "Einstellungen",
  "features.styling.tooltip.primaryLoginImage": "Laden Sie das Titelbild für die Anmeldeseite Ihres {touch}-Portals hoch.",
  "common.validation.rules.minMultiple": "Mindestens ein Wert in {field} liegt unter dem Mindestwert von {min}.",
  "features.costsPrices.strategy1Step2PerPartPrefix": "Kosten je Teil hinzufügen und Preiskategorien zuweisen in",
  "common.buttons.collapseAll": "Alle einklappen",
  "features.customers.extruderFabricator": "Fertigungsunternehmen",
  "features.basket.extraAdded": "{description} hinzugefügt",
  "features.costsPrices.advancedPricing.line1": "Die erweiterte Preisfindung gibt Ihnen die volle Kontrolle über Ihre Auftragskalkulation. Außerdem können Sie Produkte konfigurieren und Preise in Echtzeit berechnen. Anfragen, die über die Lead-Erfassungs erstellt werden, werden nach der Umwandlung in ein Angebot automatisch kalkuliert.",
  "features.store.tabLimitedSellingTimes": "Begrenzte Verkaufszeiten",
  "features.kpi.topX": "Nach oben {number}",
  "common.contact.lastName": "Nachname",
  "features.chooseProduct.partsListNotEnabledText": "Wenden Sie sich an {email}, um diese Funktion zu aktivieren. Falls die Funktion bereits erworben wurde, melden Sie sich ab und wieder an, um die Lizenz zu übernehmen.",
  "features.costsPrices.advancedPricing.line3": "Um die Einrichtung der erweiterten Preisermittlung abzuschließen, müssen Sie Folgendes konfigurieren:",
  "common.contact.contactRoles": "Kontaktrollen",
  "common.labels.cost": "Kosten",
  "features.costsPrices.possibleCombinedPricing": "Vorhandene Preisermittlungsmethoden bleiben beim Speichern erhalten. Durch die gemeinsame Anwendung mehrerer Methoden können sich die Endpreise ändern.",
  "common.menu.charges": "Kosten",
  "features.quotesAndOrders.individualItems": "Einzelne Artikel",
  "features.basket.issues": "Probleme",
  "features.basket.saveProducts": "Produkte speichern",
  "features.costsPrices.labels.knockers": "Türklopfer",
  "features.costsPrices.atLeastOneEnabled": "Mindestens ein Produkt muss aktiviert bleiben.",
  "features.dashboard.addCustomer": "Kunde hinzufügen",
  "features.store.featureBoostsRetail": "Stärkt Ihre Präsenz im Einzelhandel",
  "features.costsPrices.labels.priceMatrix": "Preismatrix",
  "features.costsPrices.labels.topRight": "Oben rechts",
  "common.validation.notRecognisedAsNumber": "{value} wird nicht als Zahl erkannt.",
  "features.customers.fabricatorEnabled": "Hersteller aktiviert",
  "features.leadCapture.setup.activateProducts": "Produkte aktivieren",
  "features.productSettings.addGroup": "Gruppe hinzufügen",
  "features.account.percentage": "Prozent",
  "features.costsPrices.labels.frame": "Rahmen",
  "features.staff.allowMoreStaff": "Weitere Mitarbeiter zu Ihrem Team hinzufügen.",
  "features.account.bccOrderConfirmations": "Bcc für Bestellbestätigungen",
  "features.leadCapture.hero.activeLine2": "{brandedMode}",
  "features.basket.itemDeleted": "Artikel gelöscht",
  "features.basket.addExtraToJob": "Zusatzoption zum Auftrag hinzufügen",
  "features.checkout.placingYourOrder": "Bestellung aufgeben",
  "features.delivery.address2": "Adresse 2",
  "features.login.newPassword": "Neues Passwort",
  "common.labels.notes": "Anmerkungen",
  "features.retailOptionsControl.hiddenOptions": "Ausgeblendete Optionen",
  "features.account.AccountCode": "Kontonummer",
  "features.visualiser.uploadHome": "Laden Sie Bilder von Ihrem Haus hoch",
  "common.status.setupComplete": "Einrichtung abgeschlossen",
  "features.store.featureShowroomText": "Steigern Sie die Interaktivität in Ihrem Ausstellungsraum, indem Sie den Konfigurator auf einem Tablet oder interaktiven Bildschirm präsentieren. Dieses leistungsstarke Marketinginstrument ermöglicht es Ihren Kunden, ihr Wunschprodukt selbst zu gestalten, ohne mühsam in veralteten Broschüren suchen zu müssen.",
  "common.labels.optionItems": "Optionen",
  "features.marketing.editCategory": "Kategorie bearbeiten",
  "features.basket.editItem": "Artikel bearbeiten",
  "features.costsPrices.labels.netPrice": "Netto",
  "features.staff.licenseLimitDefault": "Sie haben Ihr Benutzerlizenzlimit erreicht. Bitte wenden Sie sich an {fabricator}, um Ihr Limit zu erhöhen.",
  "features.basket.placeOrder": "Auftrag erteilen",
  "features.store.discoverMore": "Mehr erfahren",
  "features.customers.brandedModePromoText": "Die Unterstützung ihrer {brandedMode}-Lizenz ist die ideale Lösung. Aktivieren Sie die Lizenz für einen bestimmten Zeitraum, um die Zahl der Anfragen von Endkunden zu erhöhen. Denn wenn Ihre Kunden erfolgreicher sind, profitieren auch Sie davon.",
  "common.errors.forwardError": "Keine Sorge, das Problem wurde nicht durch Sie verursacht. Bitte teilen Sie uns mit, was passiert ist, damit wir die Ursache besser nachvollziehen können.",
  "common.labels.searchBranch": "Filiale suchen",
  "features.basket.openVirtualHome": "Virtual Home öffnen",
  "features.quotesAndOrders.unsubscribedProductsTitle": "Einige Produkte in diesem {contractType} sind nicht mehr in Ihrer Lizenz enthalten.",
  "common.labels.viewAll": "Alle anzeigen",
  "features.leadCapture.hero.activeButtonDescription": "4 Tipps zur Generierung von Anfragen",
  "common.buttons.confirmAndSave": "Bestätigen & Speichern",
  "common.labels.logo": "Logo",
  "features.costsPrices.labels.percentage": "Prozent",
  "features.quotesAndOrders.fabricatorReports": "Berichte des Herstellers",
  "common.validation.rules.maxLength": "{field} darf nicht mehr als {max} Zeichen enthalten",
  "common.status.notSelected": "nicht ausgewählt",
  "common.errors.pageNotFoundLong": "Die von Ihnen gesuchte Seite wurde nicht gefunden.",
  "features.quotesAndOrders.newOrder": "Neuer Auftrag",
  "common.labels.all": "Alle",
  "features.login.resetPassword": "Passwort zurücksetzen",
  "common.datetime.fri": "Freitag",
  "features.costsPrices.strategy1Step2PerOption": "Hinterlegen Sie Kosten je Option und weisen Sie auf den Seiten {product}, {glass}, {panel} und {slab} die entsprechenden Finanzkategorien zu.",
  "common.buttons.proceed": "Weiter",
  "common.buttons.refreshRequired": "Aktualisierung erforderlich",
  "features.store.featureOwnSystem": "Sie müssen kein eigenes System erwerben.",
  "features.login.logout": "Abmelden",
  "features.login.store": "{touch} Store",
  "features.staff.addStaff": "Mitarbeiter hinzufügen",
  "common.labels.image": "Bild",
  "features.costsPrices.editPricingForCustomers": "Preise für Kunden bearbeiten",
  "features.enquiries.dealerNetworkPartnerOnly": "Nur für Partner des Händlernetzwerks",
  "features.costsPrices.labels.jointButtWeld": "Stumpfstoß – geschweißt",
  "features.basket.addAnotherProduct": "Ein weiteres Produkt hinzufügen",
  "common.contact.mobile": "Mobil",
  "common.contact.yourAddress": "Ihre Adresse",
  "features.costsPrices.labels.nonRectangularPremium": "Zuschlag für Sonderformen",
  "features.leadCapture.company.googleAnalytics.step2.part6": "Klicken Sie unter 'Domains einbeziehen' auf 'Bedingung hinzufügen' und legen Sie den Übereinstimmungstyp auf 'Stimmt genau überein' fest.",
  "features.store.featureLeadGeneration": "Software zur Lead-Generierung",
  "features.costsPrices.pricingOverlapWarning": "Preisermittlungen können sich überschneiden, wenn Werte sowohl in der Teileliste <b>(pro Teil)</b> als auch in Produkten, Glas, Paneelen oder Füllungen <b>(pro Option)</b> hinterlegt sind. Um korrekte und nachvollziehbare Gesamtpreise sicherzustellen, sollte jede Preisregel nur an einer Stelle definiert werden.",
  "common.menu.viewOrders": "Aufträge anzeigen",
  "features.dashboard.knowledgeBase.articles.title2": "{1} Einrichtungsleitfaden",
  "features.costsPrices.strategy2Step1PerPart": "Hinterlegen Sie für jedes Teil in {partsList} einen Preis.",
  "features.leadCapture.company.googleAnalytics.step2.part3": "Klicken Sie auf 'Web' und anschließend auf einen Web-Datenstream.",
  "features.enquiries.upgrade": "Upgrade",
  "features.store.featureHomeVisualiser": "Home Visualiser",
  "common.menu.styling": "Design",
  "features.leadCapture.products.text": "Wählen Sie aus der folgenden Liste die Produkte aus, die Sie verkaufen. Diese werden anschließend in Ihrem {setup}-Designer angezeigt.",
  "features.leadCapture.styling.landingPageTitleDescription": "Geben Sie hier die Überschrift für die {setup}-Designer-Seite ein.",
  "features.store.leadCaptureLiteVersion": "{brandedMode} ist eine Lite-Version von {fabricator} Designer.",
  "features.customers.searchGroups": "Gruppen suchen...",
  "common.contact.email": "E-Mail",
  "common.labels.noLogin": "Keine Anmeldung",
  "common.labels.description": "Beschreibung",
  "features.quotesAndOrders.noteAlreadyUpdated": "{title} wurde bereits aktualisiert. Bitte aktualisieren Sie die Seite, um die Änderungen zu sehen.",
  "common.buttons.clearFilter": "Filter löschen",
  "common.menu.financialCategories": "Preiskategorien",
  "common.global.importantNotice": "Wichtiger Hinweis",
  "features.costsPrices.labels.itemColour": "Artikelfarbe",
  "common.labels.and": "und",
  "features.store.quoteOrderManagement": "Angebots- & Bestellverwaltung",
  "features.leadCapture.deployment.option1.recommended": "Empfohlen",
  "features.leadCapture.hero.inactiveButtonDescription": "Kostenlose Funktionen aktivieren",
  "features.costsPrices.labels.per": "Pro",
  "features.designer.saveToBasket": "Speichern unter {contractType}",
  "common.menu.priceList": "Preisliste",
  "features.costsPrices.labels.profiles": "Profile",
  "features.marketing.pleaseAddVideoId": "Bitte fügen Sie eine Video-ID hinzu",
  "features.customers.downloadHistoryTitle": "Download-Verlauf",
  "common.financial.productCharge": "Produktgebühr",
  "features.styling.labels.loginSubHeader": "Untertitel der Anmeldeseite",
  "features.quotesAndOrders.downloadName": "{name} herunterladen",
  "common.labels.new": "Neu",
  "features.basket.overridingDeliveryNote": "Die Versandkosten werden an der Kasse berechnet.",
  "features.leadCapture.deployment.copyURL": "URL kopieren",
  "features.costsPrices.labels.groups": "Gruppen",
  "features.checkout.addressAlreadyExists": "Diese Adresse ist für diesen Kunden bereits vorhanden.",
  "common.validation.widthMustDiffer": "Mindest- und Maximalbreite müssen unterschiedlich sein.",
  "features.visualiser.uploadStep1": "1. Importieren Sie mehrere Fotos aus Ihrer Mediathek.",
  "features.costsPrices.strategy1Step2PerPart": "Fügen Sie Kosten hinzu und weisen Sie den einzelnen Teilen in {partsList} Finanzkategorien zu.",
  "features.costsPrices.labels.simulatePriceMatrix": "Preismatrix simulieren",
  "features.store.buyLeadCapture": "{brandedMode} kaufen",
  "common.financial.supplyOnlyExtrasCharge": "Aufpreis für Extras bei Nur Lieferung",
  "features.basket.deleteOverrideTitle": "Möchten Sie diese Preisüberschreibung wirklich überschreiben?",
  "features.basket.duplicateItem": "Artikel duplizieren",
  "features.quotesAndOrders.isLockedBy": "Dieser {contractType} ist derzeit durch {firstName} {lastName} ({email}) gesperrt.",
  "features.costsPrices.labels.part": "Artikel",
  "features.quotesAndOrders.supplyOnly": "Nur Lieferung",
  "common.buttons.backToHome": "Zurück zur Startseite",
  "features.designer.customDesigner.descDummiesMidrails": "Wählen Sie 'Dummy' oder 'Mittelteil' aus und klicken Sie auf eine horizontale oder vertikale Linie im Raster, um das Element hinzuzufügen. Wiederholen Sie den Vorgang bei Bedarf.",
  "features.news.categoryNameMissing": "Kategoriename fehlt",
  "features.costsPrices.labels.tJointSquare": "Rechtwinklige T-Verbindung",
  "features.store.convertEnquiriesHeading": "Anfragen in Aufträge umwandeln",
  "features.customers.licenseLimitReached": "Lizenzlimit erreicht",
  "features.leadCapture.styling.enquiryPdfSummaryFooter": "Fußzeile der Zusammenfassung im Anfrage-PDF",
  "common.menu.paymentGateway": "Zahlungsanbieter",
  "features.styling.labels.portalLoginPageText": "Text der Portalanmeldeseite",
  "features.costsPrices.labels.volume": "Volumen",
  "common.global.cookieText": "Diese Website verwendet Cookies, um die Benutzererfahrung zu verbessern. Wir setzen Cookies ein, um den Datenverkehr und die Leistung unserer Website zu analysieren. Personenbezogene Daten erfassen wir nur, wenn dies zum Zeitpunkt der Datenerfassung ausdrücklich vereinbart wurde. In diesem Fall informieren wir Sie vorab.",
  "features.styling.labels.loginBodyText": "Text im Anmeldebereich",
  "features.leadCapture.styling.thankYouPageTextDescription": "Geben Sie hier die Überschrift für die {setup}-Designer-Dankeseite ein.",
  "features.basket.whatHappensNext": "Wie geht es nun weiter?",
  "features.leadCapture.company.googleAnalytics.step4.text": "Bei einer erfolgreichen Anfrage wird das Ereignis 'enquiry-conversion' ausgelöst.",
  "features.costsPrices.labels.items": "Artikel",
  "features.productSettings.editType": "Typ bearbeiten",
  "features.basket.markAsMeasured": "Als aufgemessen markieren",
  "features.login.superuser": "Als Super‑User anmelden",
  "features.account.disclaimerText": "Haftungsausschluss erforderlich",
  "features.leadCapture.styling.enquiryPdfImage2Purpose": "Ergänzen Sie Ihre Unterlagen mit einem Produktfoto.",
  "features.costsPrices.labels.allCorners": "Alle Ecken",
  "common.labels.heightMm": "Höhe (mm)",
  "features.costsPrices.strategy1Step3LinkLabour": "Arbeitskosten",
  "features.chooseProduct.chooseStyle": "Design auswählen",
  "features.leadCapture.setup.readyToDeploy": "{setup} ist jetzt bereit für die Bereitstellung.",
  "features.store.buyStep1": "Melden Sie sich beim {fabricator}-Portal an",
  "features.customers.atLeastOneProductEnabled": "Mindestens ein Produkt muss aktiviert sein.",
  "common.buttons.accept": "Akzeptieren",
  "features.costsPrices.labels.angled": "Abgewinkelt",
  "features.account.discountAmount": "Rabattbetrag",
  "common.status.downloaded": "Heruntergeladen",
  "common.menu.salesDashboard": "Vertriebs-Dashboard",
  "features.costsPrices.moveFinancialItemsConfirmation": " Sind Sie sicher, dass Sie {from} nach {to} verschieben möchten?",
  "common.labels.quantity": "Anzahl",
  "features.designer.invalidatedOptionsMessage": "Durch die letzte Änderung sind einige zuvor ausgewählte Optionen nicht mehr gültig. Klicken Sie hier für weitere Details.",
  "features.productSettings.noDefault": "Kein Standard",
  "features.dashboard.checklist.step1": "1. Unternehmensdaten und Logo hinzufügen",
  "features.news.noArticles": "Es sind keine Newsartikel vorhanden",
  "common.menu.dashboard": "Dashboard",
  "features.styling.labels.requote": "Angebot neu kalkulieren",
  "features.branches.searchPlaceholder": "Nach Filiale suchen...",
  "features.costsPrices.labels.cornerJointAngled": "Abgewinkelte Eckverbindung",
  "features.store.simplifiedInterface": "Eine vereinfachte Benutzeroberfläche mit weniger Optionen, über die Endkunden direkt einen Entwurf erstellen und eine Anfrage an Sie senden können.",
  "common.labels.customerType": "Kundentyp",
  "common.status.onStop": "Bei „Stop“",
  "features.marketing.noCategoryChosen": "Keine Kategorie ausgewählt",
  "common.buttons.goBack": "Zurück",
  "features.customers.paymentsSetupRequiredText": "Bitte wenden Sie sich an Ihren Kundenbetreuer, um die Zahlungsabwicklung einzurichten.",
  "features.store.subscriptionActive": "Lizenz aktiv",
  "features.quotesAndOrders.sendCustomerQuote": "Kundenangebot senden",
  "features.quotesAndOrders.selectSandbox": "Sandbox auswählen",
  "common.buttons.decline": "Ablehnen",
  "common.contact.country": "Land",
  "features.leadCapture.styling.thankYouPageBackground": "Hintergrund der Dankeseite",
  "common.labels.lengthMm": "Länge (mm)",
  "features.productSettings.selectDefault": "Standard auswählen",
  "features.costsPrices.labels.upliftPrice": "Aufschlagspreis",
  "features.customers.skipPendingOrderStaff": "Ausstehende Bestellung überspringen (Mitarbeiter)",
  "features.store.datedBrochuresProblem": "Wir wissen alle, wie teuer Broschüren sind und wie schnell sie veralten können. Ganz zu schweigen davon, sie von Haus zu Haus transportieren zu müssen.",
  "common.buttons.clickHere": "Hier klicken",
  "features.customers.extruderDesigner": "Designer",
  "features.costsPrices.heightIncrement": "Höhenschritt",
  "features.costsPrices.labels.topLeft": "Oben links",
  "features.basket.noItems": "Der Warenkorb ist leer.",
  "features.store.featureShowroom": "Sie können es in Ihrem Ausstellungsraum nutzen.",
  "features.basket.externalColour": "Außenfarbe",
  "features.store.fullyBranded": "Vollständig an Ihr Unternehmen angepasst",
  "common.status.pending": "Ausstehend",
  "features.marketing.categoryName": "Kategoriename",
  "features.quotesAndOrders.onStopText": "Für dieses Konto können keine Bestellungen aufgegeben werden. Bitte wenden Sie sich an Ihren Hersteller.",
  "features.support.manageResourcesDescription": "Stellen Sie Ihren Kunden Marketingmaterialien wie technische Leitfäden, Broschüren, Bilder, Fotos & weitere Inhalte zum Download bereit.",
  "features.store.consumerWebsiteCost": "Einmalige Kosten in Höhe von {price}",
  "features.productSettings.sashGlass": "Flügelverglasung",
  "features.delivery.latitude": "Breitengrad",
  "features.costsPrices.labels.copyTo": "Kopieren nach",
  "features.customers.customerBase": "Kundenstamm",
  "features.account.editTaxRates": "Steuersätze bearbeiten",
  "features.enquiries.leadCapture.subtext": "Enthält Virtual Home",
  "common.validation.noProductsFound": "Keine Produkte gefunden",
  "features.quotesAndOrders.downloadCuttingList": "Zuschnittliste herunterladen",
  "features.quotesAndOrders.noDownloads": "Keine Downloads",
  "common.validation.rules.numeric": "{field} muss eine Zahl sein",
  "features.leadCapture.styling.thankYouPageBodyDescription": "Geben Sie hier den Begrüßungstext für die {setup}-Designer-Dankeseite ein.",
  "features.chooseProduct.squaresQuantity": "Anzahl der Quadrate",
  "features.enquiries.noConsumerOnEnquiry": "Anfrage einem Händler zuweisen (für die Anfrage wurde kein Endkunde gefunden)",
  "features.quotesAndOrders.issuesAcknowledged": "Probleme bestätigt",
  "common.errors.forbiddenError": "Sie haben keine Berechtigung, auf diese Ressource zuzugreifen.",
  "features.basket.saveToEnquiry": "Als Anfrage speichern",
  "common.menu.labour": "Arbeitskosten",
  "features.quotesAndOrders.colourExternal": "Farbe (außen)",
  "common.status.notStarted": "Noch nicht begonnen",
  "common.buttons.retry": "Erneut versuchen",
  "features.costsPrices.labels.saveGroup": "Gruppe speichern",
  "features.leadCapture.company.googleAnalytics.step4.header": "Prüfen Sie, ob die Konversionsdaten funktionieren",
  "features.basket.makeEnquiryAndSaveVis": "Stellen Sie eine Anfrage und speichern Sie Ihre Visualisierung",
  "features.costsPrices.labels.minimumAreaForCosting": "Mindestfläche für die Kalkulation",
  "common.contact.addressPlaceholder": "Bitte geben Sie Ihre Adresse ein...",
  "features.quotesAndOrders.financialSummary": "Finanzübersicht",
  "features.basket.orderOnHoldPaymentText": "Bestätigen Sie die Kundenbestellung auf der Bestellseite und schließen Sie die Zahlung im Warenkorb ab.",
  "features.news.deletePostText": "Möchten Sie diesen Nachrichtenbeitrag wirklich löschen?",
  "common.menu.viewQuotes": "Angebote anzeigen",
  "features.basket.removeItemTitle": "Möchten Sie diesen Eintrag wirklich entfernen?",
  "features.costsPrices.labels.searchItemPlaceholder": "Nach einem Eintrag suchen, um den {type} zu bearbeiten ...",
  "features.basket.designAProduct": "Entwerfen Sie ein Produkt",
  "features.costsPrices.labels.wholeNumber": "Ganze Zahl",
  "features.styling.labels.quotation": "Angebot",
  "common.contact.customerName": "Kundenname",
  "features.marketing.editVideo": "Video bearbeiten",
  "features.designer.yesSaveProduct": "Ja, aktuelles Produkt speichern.",
  "features.leadCapture.company.newAddress": "Neue Adresse",
  "features.costsPrices.startPricingSetup": "Nutzen Sie die Registerkarten oben, um mit der Einrichtung der Preisermittlung zu beginnen.",
  "common.contact.firstName": "Vorname",
  "features.quotesAndOrders.quotesPageTitle": "Angebote suchen",
  "features.login.signIn": "Anmelden",
  "common.labels.default": "Standard",
  "common.validation.pleaseTryAgain": "Bitte versuchen Sie es erneut.",
  "features.costsPrices.labels.editList": "Liste bearbeiten",
  "features.staff.searchPlaceholder": "Mitarbeiter suchen...",
  "common.labels.departments": "Abteilungen",
  "features.leadCapture.deployment.deployTooltip": "Klicken Sie hier, um die Anleitung zur Einbindung von {setup} in Ihre Website aufzurufen.",
  "common.buttons.loadMore": "Mehr laden",
  "features.chooseProduct.stageSelectBlurb": "Bitte wählen Sie {stage} für die Phase aus.",
  "features.staff.licenseLimit": "{active} von {limit} Lizenzen zugewiesen",
  "features.enquiries.title": "Ihre Anfragen",
  "features.staff.resendActivationEmail": "Aktivierungs-E-Mail erneut senden",
  "features.store.leadCaptureForInstallers": "{brandedMode} für Installateure",
  "features.visualiser.referencePlaceholder": "z. B. mein Zuhause, das Haus meines Vaters oder das Haus meiner Mutter",
  "features.leadCapture.styling.enquiryPdfImage2Location": "Bereich: Letzte Seite des PDF-Dokuments, das an den Endkunden gesendet wird",
  "common.contact.line1": "Zeile 1",
  "features.designer.upToMm": "bis zu {max}mm",
  "features.visualiser.referenceLabel": "Geben Sie eine Referenz ein",
  "features.quotesAndOrders.quoteNumberLabel": "Angebotsnummer",
  "common.validation.rules.min": "{field} muss mindestens {min} sein",
  "features.costsPrices.labels.useProductMeasurementsTooltip": "Wählen Sie diese Option, um den Preis anhand der Produktmaße zu berechnen. Die Größenangaben können anschließend nicht mehr geändert werden.",
  "features.leadCapture.company.googleAnalytics.step2.part2": "Klicken Sie im Admin-Bereich unter 'Datenerfassung und -bearbeitung' auf 'Datenstreams'.",
  "features.costsPrices.labels.maxWidth": "Maximale Breite",
  "features.dashboard.knowledgeBase.articles.title5": "Design der Endkunden-Website",
  "common.labels.filter": "Filter",
  "features.store.registerForDemo": "Registrieren Sie sich noch heute, um Zugriff auf unsere kostenlose Demo zu erhalten.",
  "features.costsPrices.labels.listPrice": "Listenpreis",
  "features.costsPrices.setBasePrices": "Grundpreise festlegen",
  "common.validation.rules.aboveMaximum": "{value} mm liegt {diff} mm über dem Maximalwert.",
  "features.customers.ignoreAndContinue": "Ignorieren & fortfahren",
  "features.leadCapture.styling.enquiryEmailHeaderImagePurpose": "Ergänzen Sie Ihre Unterlagen mit einem Produktfoto.",
  "features.leadCapture.company.selectAddress": "Adresse auswählen",
  "features.staff.archivedStaff": "Mindestens ein Mitarbeiter muss aktiv bleiben.",
  "common.global.privacyPolicyInfo": "{clickHere}, um mehr darüber zu erfahren, wie wir Ihre personenbezogenen Daten verwenden.",
  "features.costsPrices.labels.letterplates": "Briefschlitze",
  "features.store.branchesFeatureDedicated": "Support vor Ort",
  "features.leadCapture.styling.landingPageBodyTextDescription": "Geben Sie hier den Begrüßungstext für die {setup}-Designer-Seite ein.",
  "features.basket.itemPrice": "Artikelpreis",
  "features.designer.quickTipText": "Klicken Sie auf Bereiche des Bildes, um bestimmte Teile des Produkts anzupassen. Anklickbare Bereiche umfassen den Rahmen, das Glas und weitere Bestandteile dieses Produkts.",
  "features.customers.licenseUtilisation": "Lizenznutzung",
  "features.checkout.setupDelivery": "Lieferung einrichten",
  "features.leadCapture.company.googleAnalytics.step2.header": "Domänenübergreifende Messungen einrichten",
  "features.marketing.addNewFile": "Neue Datei hinzufügen",
  "features.leadCapture.company.showDesignNamesText": "Wählen Sie zwischen Design A und Design B, wenn ein Kunde einen Produkttyp auswählt.",
  "features.delivery.addressSearch": "Adresse suchen",
  "features.styling.tooltip.portalLoginPageText": "Geben Sie den Text ein, der auf der Anmeldeseite Ihres {touch}-Portals angezeigt wird.",
  "features.delivery.address1": "Adresse 1",
  "features.store.clickToRegister": "Klicken Sie hier, um einen Preis anzufordern.",
  "common.menu.delivery": "Lieferung",
  "features.enquiries.customerIsOnStop": "{name} ist auf 'Stopp' gesetzt.",
  "features.leadCapture.styling.FooterText": "Fußzeilentext",
  "features.leadCapture.hero.expiringTag": "Handeln Sie jetzt, um online zu bleiben",
  "features.costsPrices.labels.spyholes": "Türspione",
  "features.visualiser.explorePossibilities": "Entdecken Sie unzählige Gestaltungsmöglichkeiten für den Innen- und Außenbereich.",
  "features.account.vatRegistrationNumber": "Umsatzsteuer-Identifikationsnummer",
  "features.quotesAndOrders.emailNotification": "E-Mail-Benachrichtigung",
  "common.menu.costsPrices": "Kosten/Preise",
  "common.datetime.sun": "Sonntag",
  "features.leadCapture.setup.activateProductsTextPortal": "Aktivieren Sie die Produkte für {setup}. Dabei sollte es sich um Produkte handeln, zu denen Ihre Kunden Anfragen stellen können.",
  "common.buttons.submit": "Senden",
  "features.store.buyStep4": "Lastschrift einrichten – der erste Monat ist kostenlos.",
  "features.staff.termsAndConditions": "Bitte akzeptieren Sie die allgemeinen Geschäftsbedingungen.",
  "features.leadCapture.deployment.option1.step1": "1) Klicken Sie unten auf die Schaltfläche 'URL kopieren'.",
  "features.styling.tooltip.loginPageBackgroundImage": "Laden Sie das Hintergrundbild für die Anmeldeseite Ihres {touch}-Portals hoch.",
  "features.dashboard.description": "Willkommen im Adminbereich von {company}",
  "features.enquiries.goToQuote": "Zum Angebot",
  "features.costsPrices.labels.addItem": "Artikel hinzufügen",
  "features.designer.pleaseSpecify": "Bitte angeben",
  "features.costsPrices.labels.discountCategory": "Rabattkategorie",
  "features.costsPrices.labels.keepTwoDecimals": "2 Dezimalstellen beibehalten",
  "features.visualiser.editUploadImages": "Bilder bearbeiten / hochladen",
  "common.validation.urlAndFileConflict": "URL und Datei können nicht gleichzeitig angegeben werden. Bitte wählen Sie eine der beiden Optionen.",
  "common.status.placed": "Erfasst",
  "common.labels.optional": "Optional",
  "features.enquiries.enquiryRejected": "Anfrage abgelehnt",
  "features.basket.unsubscribedProductWarning": "Dieses Produkt ist in Ihrer Lizenz nicht mehr verfügbar. Entfernen Sie es vor dem Speichern aus dem Warenkorb.",
  "features.login.forgotPasswordSubtitle": "Geben Sie Ihre E-Mail-Adresse ein, um das Passwort zurückzusetzen.",
  "features.costsPrices.labels.perKg": "pro kg",
  "features.store.howLeadCaptureHelps": "Inwiefern unterstützt {brandedMode} Ihr Unternehmen?",
  "features.customers.noDiscountsToShow": "Es werden keine Rabatte angezeigt",
  "features.leadCapture.styling.thankYouPageIntro": "Einleitung der Dankeseite",
  "features.checkout.placeOrderPendingPayment": "Auftrag mit ausstehender Zahlung erfassen",
  "features.productSettings.catalogueProducts": "Katalogprodukte",
  "common.buttons.addNew": "Neu hinzufügen",
  "features.support.welcomeTitle": "Willkommen bei „{companyName} Angebote & Bestellungen“",
  "features.costsPrices.labels.rates": "Preise",
  "features.quotesAndOrders.quotePdf": "Angebot als PDF",
  "common.validation.rules.required": "{field} ist erforderlich",
  "features.quotesAndOrders.totalPrice": "Gesamtpreis",
  "features.styling.labels.emailSubject": "E‑Mail-Betreff",
  "features.costsPrices.strategy2Step2": "{labour}-Preise hinzufügen",
  "common.buttons.update": "Aktualisieren",
  "features.login.productDescription": "Melden Sie sich hier an, um Angebote, Aufträge, Produkte, Neuigkeiten, Ressourcen und {retailType}-Anfragen für {license} zu verwalten.",
  "common.buttons.duplicate": "Duplizieren",
  "common.buttons.undo": "Rückgängig",
  "features.costsPrices.labels.profileColour": "Profilfarbe",
  "features.basket.orderOnHoldText": "Um den Auftrag verbindlich zu erteilen, verwenden Sie auf der Bestellseite die Schaltfläche „Kundenbestellung bestätigen“.",
  "features.login.setPassword": "Passwort festlegen",
  "features.customers.customerTypeCannotChange": "Der Kundentyp kann nicht geändert werden",
  "features.productSettings.mandatoryHint": "Diese Option ist immer aktiviert.",
  "features.costsPrices.failedToSetCell": "Fehler beim Aktivieren des Kontrollkästchens '{cell}'.",
  "features.costsPrices.labels.partName": "Artikelbezeichnung",
  "features.leadCapture.styling.thankYouPageBody": "Haupttext der Dankeseite",
  "features.basket.sizingWarningText": "Diese Anfrage wurde ohne Aufmaßdaten übermittelt.",
  "features.quotesAndOrders.unsubscribedProductsText": "Die unten markierten Artikel müssen aus dem Warenkorb entfernt werden, bevor der {contractType} gespeichert werden kann.",
  "features.account.selectCurrency": "Währung auswählen",
  "features.costsPrices.labels.useProductMeasurements": "Produktmaße verwenden",
  "features.store.featureOnlineShowroom": "Online, im Ausstellungsraum oder direkt beim Kunden vor Ort nutzen.",
  "features.customers.designerUrl": "Designer URL",
  "features.basket.size": "Größe",
  "features.checkout.poNumber": "Bestellnummer",
  "features.leadCapture.deployment.option2.step1": "1) Klicken Sie unten auf die Schaltfläche „iFrame kopieren“.",
  "features.marketing.fileUrl": "Datei-URL",
  "common.validation.rules.url": "{field} muss eine gültige URL sein",
  "features.kpi.ordersPlaced": "Erstellte Aufträge",
  "features.costsPrices.labels.costMatrix": "Kostenmatrix",
  "features.dashboard.checklist.setupChecklistLabel": "{product} Einrichtungs-Checkliste",
  "common.menu.defaults": "Standardwerte",
  "features.delivery.minimumOrderValue": "Mindestbestellwert",
  "features.costsPrices.labels.noMarkupToPrice": "Kein Aufschlag auf den Preis",
  "common.labels.product": "Produkt",
  "common.financial.fittingCharge": "Montagegebühr",
  "features.account.addTaxRate": "Steuersatz hinzufügen",
  "features.designer.nextQuestion": "Nächste Frage",
  "features.account.totalUses": "Gesamtnutzung",
  "features.leadCapture.hero.inactiveLine2": "Anfragen generieren mit...",
  "features.leadCapture.company.googleAnalytics.step2.text": "Ermöglicht die eindeutige Zuordnung von Aktivitäten zu einem Benutzer über verschiedene Domains hinweg.",
  "common.contact.contactNumber": "Kontaktnummer",
  "common.menu.pendingOrders": "Ausstehende Aufträge",
  "features.news.manageCategories": "Kategorien verwalten",
  "features.basket.dealerContact": "Einer unserer Händler wird sich in Kürze mit Ihnen in Verbindung setzen.",
  "features.quotesAndOrders.placedPaymentPending": "Bestellt (Zahlung ausstehend)",
  "features.staff.activationEmailResent": "Aktivierungs-E-Mail erneut gesendet",
  "features.leadCapture.setup.businessDocumentsTextBusiness": "Um Online-Anfragen zu generieren, müssen Nutzungsbedingungen und eine Datenschutzerklärung bereitgestellt werden.",
  "common.datetime.mo": "Mo",
  "features.store.clickToLiveChat": "Klicken Sie hier für den Live-Chat",
  "features.leadCapture.styling.landingPageBackground": "{setup} Hintergrund der Landingpage",
  "common.labels.order": "Auftrag",
  "features.delivery.longitude": "Längengrad",
  "features.productSettings.optionItem": "Optionen",
  "features.productSettings.sourceClearances": "Referenzabstände",
  "common.menu.paperwork": "Unterlagen",
  "features.leadCapture.hero.sellMore": "Mehr verkaufen",
  "common.labels.isBetween": "ist zwischen",
  "features.customers.remaining": "verbleibend",
  "features.leadCapture.products.showToConsumers": "Für Endkunden anzeigen",
  "features.login.loginError": "Anmeldung nicht möglich. Bitte überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort und versuchen Sie es erneut.",
  "features.account.contractValidityPeriod": "Vertragslaufzeit",
  "features.costsPrices.labels.bottomRightCost": "Kosten unten rechts",
  "features.costsPrices.strategy1Step1": "{financialCategories} und Aufschlagssätze festlegen",
  "features.staff.addStaffMember": "Mitarbeiter hinzufügen",
  "common.labels.features": "Funktionen",
  "features.visualiser.uploadStep5": "5. Zum Angebot hinzufügen oder an einen Freund senden.",
  "features.designer.finishedEditingComponents": "Bearbeitung der Komponenten abgeschlossen",
  "features.costsPrices.labels.jointCornerAngledWeld": "Abgewinkelte Eckverbindung – geschweißt",
  "features.chooseProduct.chooseVarProduct": "Wählen Sie {product}",
  "features.quotesAndOrders.supplierNotes": "Anmerkungen des Lieferanten",
  "features.store.selectaDescription2": "Für die Verwendung auf Ihrer Website, in Ihrem Ausstellungsraum, beim Kunden vor Ort oder in sozialen Medien.",
  "features.quotesAndOrders.orderNumber": "Auftrag {number}",
  "features.login.forgotPasswordTitle": "Passwort vergessen?",
  "features.basket.editPriceTooltip": "{price} bearbeiten",
  "features.account.addVoucher": "Gutschein hinzufügen",
  "common.status.imported": "Importiert",
  "features.productSettings.fixedGlass": "Festverglasung",
  "features.dashboard.checklist.setupChecklistDescription": "Klicken Sie auf einen Abschnitt unten, um direkt dorthin zu wechseln.",
  "common.status.saved": "Gespeichert",
  "features.styling.tooltip.emailAddress": "Geben Sie die Absender-E-Mail-Adresse für {label} an.",
  "features.leadCapture.products.showOn": "In {setup} anzeigen",
  "features.dashboard.brochures": "Broschüren & Anleitungen",
  "common.labels.retail": "Endkundengeschäft",
  "features.basket.jobPrice": "Auftragspreis",
  "common.global.cookieTitle": "Cookie-Hinweis",
  "features.store.howToBuyText2": "Denken Sie daran: {brandedMode} beinhaltet einen kostenlosen Monat und kann jederzeit gekündigt werden.",
  "features.costsPrices.failedToLoadGrid": "Raster konnte nicht geladen werden.",
  "features.customers.extruderReseller": "Wiederverkäufer",
  "features.costsPrices.labels.perOption": "Pro Option",
  "common.contact.county": "Landkreis",
  "features.basket.priceSubjectToSurvey": "Preis vorbehaltlich Aufmaß und technischer Spezifikation.",
  "features.productSettings.newDefault": "Neuer Standard",
  "features.quotesAndOrders.customerNotes": "Kundenhinweise",
  "features.store.branchesFeatureLocalQuoting": "Lokale Angebotserstellung und Bestellabwicklung",
  "common.validation.confirmSaveText": "Die Änderungen werden sofort in der Live-Umgebung veröffentlicht. Möchten Sie die Änderungen wirklich speichern?",
  "common.menu.product": "Produkt",
  "features.basket.teamContact": "Ein Mitarbeiter unseres Teams wird sich in Kürze mit Ihnen in Verbindung setzen.",
  "common.global.maintenanceSorryText": "Entschuldigen Sie die Unannehmlichkeiten. Bitte versuchen Sie es in Kürze erneut.",
  "common.labels.group": "Gruppe",
  "features.leadCapture.company.requestMeasurementsText": "Möchten Sie über den {setup}-Designer Aufmaßdaten von Ihren Kunden anfordern? Falls ja, wird diese Frage auf dem Einführungsbildschirm angezeigt.",
  "features.enquiries.leadCaptureEnquiries": "{brandedMode} Anfragen",
  "features.basket.enquirySummaryEmail": "Sie erhalten umgehend eine E-Mail mit einer Zusammenfassung Ihrer Anfrage.",
  "features.news.addCategory": "Kategorie hinzufügen",
  "features.checkout.actionRequiredText": "Richten Sie eine Lieferadresse und mindestens einen Liefertag ein, um Ihre Lizenz zu aktivieren.",
  "common.labels.surveyor": "Aufmaßtechniker",
  "features.basket.voucherCode": "Gutscheincode",
  "features.leadCapture.company.iframeRedirect": "iFrame‑Weiterleitung",
  "features.store.easySetup": "Easy Setup",
  "features.costsPrices.labels.perPart": "Pro Teil",
  "features.account.noTaxRatesToShow": "Keine Steuersätze vorhanden.",
  "common.datetime.mon": "Mo",
  "features.quotesAndOrders.editCustomer": "Kunde bearbeiten",
  "common.labels.title": "Titel",
  "features.customers.activatedByCustomer": "Vom Kunden aktiviert. Der Kunde muss {brandedMode} deaktivieren, bevor der Hersteller diese Funktion aktivieren kann.",
  "common.buttons.start": "Start",
  "common.labels.requoteMarkup": "Aufschläge neu berechnen",
  "features.store.featureAddPrices": "Preise zu Angeboten hinzufügen",
  "features.costsPrices.labels.designs": "Designs",
  "features.store.buyStep6": "Veröffentlichen Sie den Inhalt auf Ihrer Website",
  "common.menu.cancelledOrders": "Stornierte Aufträge",
  "features.store.quotingText": "Alle Anfragen werden direkt in Ihrem Portal-Konto bei {fabricator} erfasst. Wandeln Sie die Anfrage einfach in ein Angebot um und hinterlegen Sie Ihren Verkaufspreis.",
  "features.customers.leadCaptureSubscriptions": "{brandedMode}-Lizenzen",
  "common.financial.taxRates": "Steuersätze",
  "features.styling.tooltip.loginSubHeader": "Geben Sie hier die Unterüberschrift für Ihre Portalanmeldeseite ein.",
  "features.styling.labels.metaTitle": "Meta-Titel",
  "features.account.showArticleOnDashboard": "Dieser Artikel wird unter {link} angezeigt.",
  "common.validation.heightMustDiffer": "Mindest- und Maximalhöhe müssen unterschiedlich sein.",
  "features.leadCapture.deployment.option1.step3": "3) Sobald die Links hinzugefügt wurden, ist Ihr {setup} auf Ihrer Website live. Änderungen an Ihren Einstellungen werden automatisch für Ihr Live-{setup} übernommen.",
  "features.basket.unsavedText": "Durch Fortfahren wird die vorhandene {type} im Warenkorb ersetzt.",
  "common.labels.step": "Schritt",
  "features.marketing.addCategory": "Kategorie hinzufügen",
  "features.store.featureNoSalesman": "Ein Vertriebsmitarbeiter ist nicht erforderlich.",
  "common.global.termsAndConditionsInfo": "{clickHere} um unsere Allgemeinen Geschäftsbedingungen einzusehen.",
  "features.designer.customDesigner.tabTransomsMullions": "Riegel/Pfosten",
  "common.contact.salesContact": "Vertriebskontakt",
  "features.chooseProduct.noGroupsFoundTitle": "Keine Gruppen gefunden",
  "features.designer.saveToType": "Speichern unter {contractType}",
  "features.basket.itemsHaveIssuesTitle": "Bei einigen Ihrer Artikel liegen Probleme vor",
  "features.basket.deleteStockItemConfirm": "Diesen Lagerartikel löschen?",
  "features.basket.hardwareColour": "Beschlagsfarbe",
  "features.quotesAndOrders.quoteCustomer": "Erstellen Sie ein Angebot für Ihren Kunden.",
  "features.customers.customerEnabled": "Kunde aktiviert",
  "features.leadCapture.styling.thankYouPageIntroDescription": "Geben Sie hier die Unterüberschrift für die {setup}-Designer-Dankeseite ein.",
  "features.enquiries.filterByCompanyName": "Nach Unternehmensnamen filtern...",
  "features.costsPrices.labels.modifySelected": "Auswahl bearbeiten",
  "features.branches.branchDetails": "Filialdaten",
  "features.news.searchPlaceholder": "Nachrichten suchen...",
  "features.chooseProduct.orderQty": "Auftragsmenge",
  "features.designer.quickTipTitle": "Kurztipp",
  "features.news.title": "News",
  "features.enquiries.enquiryNumber": "Anfragenummer",
  "features.costsPrices.labels.grid": "Raster",
  "features.retailOptionsControl.tooltips.optionItems": "Einzelne Optionen für den Retail Designer aktivieren oder deaktivieren",
  "common.status.success": "Erfolg",
  "features.enquiries.cannotDeleteLastJob": "Der letzte Auftrag im Vertrag kann nicht gelöscht werden.",
  "common.datetime.tuesday": "Dienstag",
  "features.basket.itemsHaveIssuesText": "Überprüfen Sie Ihre Artikel mit Problemen, bevor Sie fortfahren.",
  "features.costsPrices.labels.baseFrameCost": "Grundkosten Rahmen",
  "common.labels.newBuild": "Neubau",
  "common.menu.imagesAndText": "Bilder & Text",
  "features.launch.licenseNotActive": "Wenn Sie der Lizenzinhaber dieser Software sind, ist Ihre Softwarelizenz nicht mehr aktiv.",
  "features.leadCapture.company.uploadGdprDocuments": "Laden Sie Ihre DSGVO-Dokumente hoch",
  "features.staff.licenseLimitExtruder": "Sie haben das Limit Ihrer Benutzerlizenzen erreicht. Entziehen Sie einem bestehenden Benutzer eine Lizenz, um fortzufahren.",
  "features.login.step2": "Bitte bestätigen Sie Ihre E-Mail-Adresse",
  "features.delivery.deliveryDate": "Liefertermin",
  "common.validation.rules.minLength": "{field} muss mindestens {min} Zeichen enthalten",
  "features.quotesAndOrders.confirmation": "Bestätigung",
  "common.labels.quote": "Angebot",
  "features.costsPrices.setupPricing": "Wie möchten Sie Ihre Preisermittlung einrichten?",
  "features.account.kpiSettings": "KPI-Einstellungen",
  "features.styling.tooltip.emailSubject": "Passen Sie die Betreffzeile für {label}-E-Mails an Endkunden an.",
  "features.designer.customDesigner.overallWidth": "Gesamtbreite",
  "features.leadCapture.setup.activateProductsTooltip": "Diese Produkte können angeboten und bestellt werden.",
  "features.visualiser.uploadStep3": "3. Visualisieren Sie die komplette Fassade Ihres Hauses.",
  "features.basket.localCurrencyLabel": "Lokale Währung ({code})",
  "features.costsPrices.labels.roundToWholeNumber": "Auf ganze Zahlen runden",
  "features.leadCapture.company.googleAnalytics.step3.part1": "Öffnen Sie eine Seite Ihrer Website, die einen Link zum {setup}-Modus enthält.",
  "features.leadCapture.hero.inactiveButtonText": "{brandedMode} ausprobieren",
  "common.labels.index": "Index",
  "features.quotesAndOrders.itemsPrice": "Artikel Preis",
  "features.basket.addExtra": "Zusatzoption hinzufügen",
  "common.status.notFound": "Nicht gefunden",
  "features.store.gotAQuestion": "Haben Sie eine Frage zu diesen Produkten?",
  "common.buttons.watch": "Ansehen",
  "common.labels.name": "Name",
  "features.designer.changeFrameDesigns": "Fertigrahmen ändern",
  "features.enquiries.unableToDelete": "Kann nicht gelöscht werden",
  "features.store.howToBuyText1": "Einfacher geht es nicht. Sobald Ihre Lastschrift eingerichtet ist, können Sie innerhalb weniger Minuten auf Ihrer eigenen Website live gehen.",
  "features.customers.addCustomer": "Kunde hinzufügen",
  "features.dashboard.helpGuides": "Anleitungen",
  "features.customers.retailCustomerDescription": "<strong>Privatkunden</strong><br>Endkundendaten sind in der Administration für Aufträge sichtbar.<br>Aufträge werden als Liefer- & Montageaufträge gekennzeichnet.<br>Zusatzoptionen für reine Lieferaufträge sowie für Liefer- & Montageaufträge sind verfügbar.<br>Lieferkosten werden nicht berechnet.",
  "common.labels.reassign": "Neu zuweisen",
  "features.basket.thanksEnquiry": "Vielen Dank für Ihre Anfrage.",
  "common.labels.summary": "Zusammenfassung",
  "features.basket.measurements": "Maße",
  "features.visualiser.uploadTip5": "Querformat (breiter als hoch).",
  "features.quotesAndOrders.featureUnavailableText": "Aktuell können keine Aufträge erstellt werden. Bitte wenden Sie sich an den Support.",
  "features.news.titleRequired": "Bitte wählen Sie einen Titel für diesen Beitrag aus",
  "features.customers.confirmRemoveExpiryDate": "Möchten Sie das Ablaufdatum für {name} wirklich entfernen?",
  "features.quotesAndOrders.discountAppliedToItem": "Der Rabattcode <u>{code}</u> wurde auf eine Position dieser Bestellung angewendet.",
  "features.leadCapture.styling.enquiryPdfImage1Location": "Bereich: Erste Seite des PDF-Dokuments, das an den Endkunden gesendet wird",
  "features.visualiser.uploadTip1": "Mindestens 1.600 Pixel breit.",
  "features.chooseProduct.chooseProduct": "Produkt auswählen",
  "features.retailOptionsControl.tooltips.productsFilter.line2": "Hinweis: Durch das Filtern wird nur die hier hervorgehobene Anzeige geändert. Die gespeicherte Reihenfolge der Optionen bleibt unverändert.",
  "features.support.title": "Kundensupport",
  "features.leadCapture.deployment.option1.step2": "2) Fügen Sie diesen Link auf Ihrer Website ein. Wir empfehlen, ihn mit einer Schaltfläche oder einem Banner zu verknüpfen. Sie können den Link auch in die Navigation Ihrer Website integrieren.",
  "features.checkout.deliveryDateSection": "2. Gewünschter Liefertermin und Anmerkungen",
  "features.customers.leadCapturePartner": "{brandedMode} Partner",
  "features.leadCapture.styling.enquiryPdfImage1": "Bild 1 für das Anfrage-PDF",
  "features.store.branchesHeading": "{name} - {price} {perMonth}",
  "features.customers.tradeCustomerDescription": "<strong>Fachhändler</strong><br>Endkundendaten sind in der Administration für Aufträge nicht sichtbar.<br>Aufträge werden als reine Lieferaufträge gekennzeichnet.<br>Es sind nur Zusatzoptionen für reine Lieferaufträge verfügbar.<br>Lieferkosten können berechnet werden.",
  "common.buttons.resendEmail": "E-Mail erneut senden",
  "features.store.poweredBy": "{brandedMode} unterstützt von {fabricator}",
  "features.productSettings.types": "Typen",
  "common.financial.subtotal": "Zwischensumme",
  "common.labels.size": "Größe",
  "features.basket.savingWarning": "Bitte klicken Sie nicht auf die Schaltfläche 'Zurück' oder 'Aktualisieren'.",
  "common.status.refused": "Abgelehnt",
  "features.basket.enquirySummaryCheckEmail": "Sie erhalten umgehend eine E-Mail mit einer Zusammenfassung Ihrer Anfrage. Bitte prüfen Sie auch Ihren Spam-Ordner, da die E-Mail dort möglicherweise eingeht. Nachdem wir Ihre Anfrage geprüft haben, wird sich ein Mitglied unseres Teams in Kürze mit Ihnen in Verbindung setzen.",
  "features.costsPrices.labels.sash": "Flügel",
  "features.leadCapture.styling.consumerEmail": "E-Mail an den Endkunden zur Bestätigung, dass die neue {setup} Ihrem festgelegten Händler zugewiesen wurde.",
  "features.designer.externalView": "Extern",
  "features.login.stepsLabel": "In vier einfachen Schritten",
  "features.launch.contactSales": "Bitte wenden Sie sich an unser Vertriebsteam, um Ihre Lizenz zu verlängern und weiterhin Anfragen zu erfassen.",
  "features.designer.switchProductText": "Möchten Sie zurückgehen und ein anderes Produkt auswählen?",
  "features.login.setPasswordSubtitle": "Geben Sie ein Passwort ein.",
  "features.designer.customDesigner.tabShape": "Form",
  "features.costsPrices.labels.surveyMarkup": "Aufmaßkosten",
  "features.leadCapture.styling.landingPageIntroDescription": "Geben Sie hier die Unterüberschrift für die {setup}-Designer-Seite ein.",
  "common.buttons.rename": "Umbenennen",
  "features.account.usesPerAccount": "Nutzungen pro Konto",
  "features.account.deleteThisCurrency": "Möchten Sie die Währung wirklich löschen?",
  "features.news.categoryNameMissingText": "Bitte geben Sie einen Kategorienamen ein.",
  "features.account.addCurrency": "Währung hinzufügen",
  "features.designer.customDesigner.customShape": "Benutzerdefinierte Form",
  "features.costsPrices.labels.cillJoint": "Fensterbankstoß",
  "features.chooseProduct.partsListNotEnabledTitle": "Stücklistenverarbeitung nicht aktiviert.",
  "features.designer.customDesigner.descSizes": "Geben Sie die Gesamtbreite und -höhe Ihres Entwurfs in Millimetern ein. Dadurch wird die Grundgröße des Entwurfs festgelegt.",
  "features.costsPrices.lessThanOrEqualTo": "<u>{fieldKeyA}</u> muss <strong>kleiner oder gleich</strong> <u>{fieldKeyB}</u> sein",
  "features.designer.viewProduct": "Produkt anzeigen",
  "common.global.termsAndConditionsName": "Allgemeine Geschäftsbedingungen",
  "features.customers.liveUnlicensed": "Live (nicht lizenziert)",
  "features.checkout.makePayment": "Bezahlen",
  "features.store.featureBoostsRetailText": "Stärken Sie Ihre Online-Präsenz, indem Sie Besucher länger auf Ihrer Website halten und die Interaktivität erhöhen. Nutzen Sie die Möglichkeiten von {brandedMode}, um Ihr Angebot hervorzuheben und Ihre Marketingaktivitäten noch wirkungsvoller zu gestalten.",
  "features.designer.internalView": "Intern",
  "common.validation.contractSaveTimeout": "Das Speichern des Vertrags dauert länger als erwartet. Aktualisieren Sie die Seite, um den aktuellen Status anzuzeigen.",
  "features.basket.supplyAndFit": "Lieferung & Montage",
  "features.designer.maximumIs": "{description} maximal {max}mm",
  "features.customers.searchPlaceholder": "Kunde suchen...",
  "features.leadCapture.styling.manageStyling": "Designs verwalten",
  "features.dashboard.checklist.step5b": "Sie können jetzt Leads über Ihre Website, Ihre Social-Media-Kanäle oder Ihren Showroom generieren.",
  "features.costsPrices.labels.decorations": "Dekorationen",
  "features.designer.addExtraToItem": "Zusatzoption zum Artikel hinzufügen",
  "features.costsPrices.strategy1Step1Prefix": "Einrichten",
  "features.quotesAndOrders.financialSummaryCSV": "Finanzübersicht (CSV)",
  "features.customers.brandedModePromo": "Möchten Sie Ihren Kunden einen Vorteil bieten?",
  "features.costsPrices.basePrice": "Grundpreis: {width} x {height}",
  "features.designer.advancedSelectionsWillReset": "Ihre erweiterten Auswahlkriterien werden zurückgesetzt.",
  "features.leadCapture.styling.emailSubject": "E‑Mail-Betreff",
  "common.labels.type": "Typ",
  "features.customers.mustHaveOneProductEnabled": "Mindestens ein Produkt muss aktiviert sein.",
  "features.productSettings.editGroup": "Gruppe bearbeiten",
  "features.costsPrices.strategy2Step2Suffix": "Preise",
  "features.account.hiddenArticles": "Ausgeblendete Artikel",
  "common.menu.alternateGlassClearance": "Alternativer Glasabstand",
  "features.store.featureReInputOrders": "Keine erneute Erfassung von Bestellungen erforderlich.",
  "common.labels.statusIs": "Status {is} {status}",
  "features.store.bespokeWebsite": "Individuelle Website",
  "features.quotesAndOrders.quoteNumber": "Angebot {number}",
  "features.leadCapture.company.requestMeasurements": "Aufmaßdaten anfordern",
  "common.contact.address2": "Adresszeile 2",
  "features.designer.customDesigner.descCreateDesign": "Klicken Sie auf „Absenden“, um Ihren Entwurf zu erstellen.",
  "features.customers.defaultTaxRateRequired": "Standardsteuersatz erforderlich.",
  "features.costsPrices.labels.weight": "Gewicht",
  "features.store.setupDirectDebit": "Lastschrift einrichten",
  "features.leadCapture.setup.activateYourProducts": "Aktivieren Sie Ihre Produkte",
  "features.enquiries.emptyDescription": "Alle Anfragen von {retail} werden hier eingehen.",
  "features.customers.customerStatus": "Kundenstatus",
  "common.labels.day": "Tag",
  "common.status.expiring": "Läuft ab",
  "features.quotesAndOrders.customerQuote": "Kundenangebot",
  "features.dashboard.helpDocs": "{touch} Support-Dokumente",
  "features.chooseProduct.yourPartsList": "Ihre Teileliste",
  "features.store.closingSaleProblem": "Ein Kunde könnte bereits Angebote von Mitbewerbern in Ihrer Region erhalten haben.",
  "features.basket.saveUnavailableText": "Entfernen Sie abgemeldete Produkte vor dem Speichern.",
  "features.leadCapture.setup.completeFirstTwoSteps": "Um den Designer für {setup} einzurichten, müssen zunächst die ersten beiden Schritte abgeschlossen werden.",
  "common.buttons.addFile": "Datei hinzufügen",
  "features.checkout.placingOrderPendingPayment": "Auftrag mit ausstehender Zahlung wird erfasst",
  "features.quotesAndOrders.contractTypeDetails": "{contractType} Details",
  "common.buttons.refresh": "Aktualisieren",
  "features.staff.licenseLimitReachedTitle": "Lizenzlimit erreicht",
  "features.account.holidays": "Feiertage",
  "common.global.needHelpCallUs": "Benötigen Sie Hilfe? Rufen Sie uns an unter {phoneNumber}",
  "features.leadCapture.products.atLeastOneProductRequired": "Mindestens ein Produkt muss aktiviert bleiben.",
  "features.leadCapture.styling.virtualHomeBannerLocation": "Bereich: Warenkorbseite",
  "features.basket.extrasSearch": "Erweiterte Suche",
  "features.branches.saveBranch": "Filiale speichern",
  "features.leadCapture.company.thankYouPageRedirect": "Weiterleitung nach der Dankeseite",
  "features.enquiries.businessSearchPlaceholder": "Anfragen nach Endkundendaten oder Postleitzahl suchen.",
  "features.kpi.period": "Zeitraum",
  "features.quotesAndOrders.saveError": "Beim Speichern dieses Auftrags ist ein Problem aufgetreten.",
  "features.account.noSavedAddresses": "Sie haben keine gespeicherten Adressen.",
  "common.labels.licenseIs": "Lizenz {is} {status}",
  "features.leadCapture.company.designB": "Design B",
  "common.datetime.tue": "Dienstag",
  "features.basket.enquirySummaryDealerNetwork": "Sie erhalten eine E-Mail mit einer Zusammenfassung Ihrer Anfrage. Ihre Angaben werden an einen regionalen Fachpartner weitergeleitet, der Ihnen einen unverbindlichen Kostenvoranschlag erstellt.",
  "features.leadCapture.hero.activeList4": "Und vieles mehr …",
  "features.customers.confirmEnableBrandedMode": "Sind Sie sicher, dass Sie <strong><u> {brandedMode} für {name}</u></strong> aktivieren möchten?",
  "features.leadCapture.styling.virtualHomeBackgroundLocation": "Bereich: Virtual Home",
  "features.delivery.addressManual": "Adresse 1 (Manueller Modus – Autovervollständigung deaktiviert)",
  "features.checkout.chargeToAccountWith": "Konto von {name} belasten",
  "features.styling.labels.primaryLoginImage": "Hauptbild der Anmeldeseite",
  "features.dashboard.text": "Hallo {name}...",
  "features.quotesAndOrders.measurements": "Maße",
  "features.account.allArticlesVisible": "Alle Artikel sind sichtbar.",
  "features.costsPrices.labels.buttJoint": "Stumpfstoß",
  "common.labels.products": "Produkte",
  "common.validation.rules.pattern": "{field} hat ein ungültiges Format",
  "features.store.buyStep5": "Mit Kontaktdaten & Logo einrichten",
  "common.buttons.saveShort": "Speichern",
  "common.menu.costList": "Kostenliste",
  "features.costsPrices.labels.doorColour": "Türfarbe",
  "common.labels.outside": "Außen",
  "features.store.inPartnershipWith": "In Zusammenarbeit mit",
  "features.productSettings.sourceOverlapsTooltip": "Profile mit einem Referenzabstand von <b>{value} mm</b>",
  "features.account.saveWorkingDays": "Arbeitstage speichern",
  "features.designer.supplyDimensionsBeforeSaving": "Vor dem Speichern müssen Maße angegeben werden.",
  "features.designer.issueRestriction": "Einschränkung (Genehmigung des Herstellers erforderlich)",
  "features.visualiser.newProducts": "Ihre neuen Produkte",
  "common.financial.defaultTaxRate": "Standardsteuersatz",
  "features.account.addQuoteStage": "Angebotsphase hinzufügen",
  "features.designer.editComponents": "Einzelne Komponenten bearbeiten",
  "common.errors.forbiddenErrorText": "Sollten Sie der Meinung sein, dass es sich hierbei um einen Fehler handelt, aktualisieren Sie bitte die Seite oder melden Sie sich erneut an.",
  "features.login.confirmPassword": "Passwort bestätigen",
  "features.designer.customDesigner.tabSizes": "Größen",
  "features.enquiries.consumerDetails": "Endkundendaten",
  "features.leadCapture.company.googleAnalytics.step2.part5": "Klicken Sie im Bereich 'Einstellungen' auf 'Domains konfigurieren'.",
  "features.quotesAndOrders.customerName": "Kunde ({name})",
  "common.status.sent": "Gesendet",
  "common.financial.priceExclTax": "Preis (zzgl. MwSt.)",
  "common.labels.adminUser": "Admin-Benutzer",
  "common.menu.news": "News",
  "features.launch.startDesigning": "Beginnen Sie mit der Gestaltung",
  "features.enquiries.assignedTo": "Zugewiesen an",
  "features.kpi.daysAgo": "Die letzten {days} Tage",
  "features.checkout.discountCode": "Rabatt ({code})",
  "common.status.expired": "Abgelaufen",
  "common.labels.optionHeadings": "Optionsüberschriften",
  "features.support.manageResources": "Medien verwalten",
  "features.leadCapture.company.contractConfirmation": "Alle Angebots- und Auftragsbestätigungen werden an diese Adresse gesendet.",
  "features.basket.voucherPlaceholder": "Geben Sie einen Gutscheincode für dieses {type} ein ...",
  "features.dashboard.knowledgeBase.articles.title1": "So kaufen Sie {1}",
  "features.basket.leaveText": "Dieser Vertrag wird beim Verlassen aus dem Warenkorb entfernt.",
  "features.login.haveAccount": "Haben Sie bereits ein Konto?",
  "features.quotesAndOrders.portalVisibility": "Sichtbarkeit des Portals",
  "features.store.featurePersonalisedPaperwork": "Individuell angepasste Unterlagen",
  "features.account.updateExchangeRates": "Wechselkurse aktualisieren",
  "features.designer.customDesigner.overallHeight": "Gesamthöhe",
  "features.costsPrices.strategy1Title": "Strategie 1: Kosten + Aufschlag",
  "common.labels.expiryDate": "Ablaufdatum",
  "common.financial.totalIncTax": "Gesamtbetrag inkl. MwSt.",
  "common.menu.productSettings": "Produkteinstellungen",
  "features.leadCapture.freeTrial.useAdmin": "Die kostenlose Testversion von {company}der Lead-Erfassung kann nur über das Administratorkonto Ihres Unternehmens aktiviert werden.",
  "features.chooseProduct.stageSelectProduct": "Bitte wählen Sie eine/n {name} aus",
  "features.store.buyStep2": "Klicken Sie auf die Schaltfläche „QUOTILA Store“",
  "features.quotesAndOrders.downloadPanelOrder": "Paneelbestellung herunterladen",
  "features.store.freeForOneMonth": "1 Monat lang kostenlos.",
  "common.menu.basket": "Warenkorb",
  "features.store.wowCustomers": "Kunden begeistern & den Umsatz steigern",
  "features.costsPrices.strategy2Description": "Geben Sie Festpreise ein, ohne dass ein Aufschlag berechnet wird.",
  "common.buttons.download": "Herunterladen",
  "features.basket.viewIssues": "Probleme anzeigen",
  "features.quotesAndOrders.generatingFabricatorReports": "Erstellung von Fertigungsberichten",
  "features.leadCapture.company.googleAnalytics.compatibleWith": "Nicht kompatibel mit Einbindungsart 2 (Anzeige im iFrame). Bitte wählen Sie Einbindungsart 1.",
  "features.costsPrices.labels.jointCruciformWeld": "Kreuzverbindung – geschweißt",
  "features.costsPrices.pricesSplitInto": "Für diese Kategorie werden die Preise wie folgt aufgeteilt:",
  "common.buttons.addVideo": "Video hinzufügen",
  "features.quotesAndOrders.quotedBy": "Angeboten von",
  "features.designer.setupNow": "Jetzt einrichten",
  "common.contact.phoneNumber": "Telefonnummer",
  "features.store.featureNoSalesmanText": "{brandedMode} ist rund um die Uhr auf Ihrer Website verfügbar. So können Sie auch dann Anfragen generieren, wenn Sie mit anderen wichtigen Aufgaben beschäftigt sind. {brandedMode} ist eine kosteneffiziente Erweiterung Ihres Teams.",
  "features.account.processingSettings": "Verarbeitungseinstellungen",
  "features.customers.customerDisabled": "Kunde deaktiviert",
  "common.menu.knowledgeBase": "Wissensdatenbank",
  "features.quotesAndOrders.confirmCustomerOrder": "Kundenbestellung bestätigen",
  "common.status.verified": "Verifiziert",
  "features.costsPrices.labels.customerPrice": "Kundenpreis",
  "common.menu.manageNews": "News verwalten",
  "features.delivery.saveCoordinates": "Koordinaten speichern",
  "features.costsPrices.labels.minimumAreaForPricing": "Mindestfläche für die Preisermittlung",
  "features.costsPrices.labels.topRightCost": "Kosten oben rechts",
  "features.leadCapture.styling.virtualHomeBackground": "Virtual Home Hintergrund",
  "common.datetime.thursday": "Donnerstag",
  "common.validation.fileSizeExceeded": "Die Dateigröße überschreitet die maximale Größe von {mb} MB.",
  "features.designer.issueWarning": "Warnung",
  "features.costsPrices.labels.copiedFrom": "Kopiert von",
  "common.contact.deliveryAddresses": "Lieferadressen",
  "features.account.saveHoliday": "Feiertage speichern",
  "features.quotesAndOrders.cancelOrder": "Bestellung stornieren",
  "features.costsPrices.strategy1Step2PerPartLink": "Teileliste",
  "common.validation.referenceRequired": "Geben Sie eine Referenz ein.",
  "features.dashboard.knowledgeBase.articles.title6": "Design der Händlerwebsite",
  "features.account.issuePresentWarningPlaceholder": "Text zur Genehmigung von Bestellungen mit Positionen, für die Warnungen vorliegen.",
  "common.menu.viewEnquiries": "Anfragen anzeigen",
  "features.marketing.categoryEmpty": "Diese Kategorie ist leer.",
  "common.labels.error": "Fehler",
  "features.chooseProduct.chooseType": "Typ auswählen",
  "common.menu.createOrder": "Auftrag erstellen",
  "common.menu.support": "Quick Support",
  "common.labels.widthMm": "Breite (mm)",
  "features.leadCapture.hero.activeButtonText": "{brandedMode} Tipps",
  "features.news.categoryName": "Kategoriename",
  "features.designer.threeDVisualisation": "3D-Visualisierung",
  "features.login.registerButton": "Registrieren",
  "features.costsPrices.labels.viewColourGroups": "Farbgruppen anzeigen",
  "features.store.quoteHeading": "Steigern Sie Ihren Gewinn:<br />Hinterlegen Sie Preise in Angeboten.",
  "features.store.viewLeadCaptureDemo": "{brandedMode} Demo ansehen",
  "features.store.branchesFeatureIndependentCustomer": "Unabhängige Kundenverwaltung",
  "features.delivery.adjustCoordinates": "Koordinaten anpassen",
  "features.store.limitedSellingTimesSolution": "{brandedMode} ist direkt über Ihre Website verfügbar und ermöglicht Besuchern, Produkte zu konfigurieren, Entwürfe zu erstellen und Anfragen zu stellen – jederzeit und ganz nach Bedarf.",
  "features.visualiser.startVisualising": "Beginnen Sie mit der Visualisierung",
  "features.checkout.requestedDeliveryDate": "Gewünschter Liefertermin",
  "common.datetime.sa": "Sa",
  "features.account.pleaseSelectCurrency": "Bitte wählen Sie eine Währung aus",
  "features.costsPrices.labels.piece": "Stück",
  "features.basket.overridingItemPriceNote": "Die Änderungen werden im Auftragspreis berücksichtigt.",
  "common.menu.discounts": "Rabatte",
  "features.basket.noItemsInBasket": "Keine Artikel im Warenkorb.",
  "features.account.installationSettings": "Installationseinstellungen",
  "common.financial.incVat": "(inkl. MwSt.)",
  "features.enquiries.refusalQuestion": "Warum lehnen Sie diese Anfrage ab?",
  "features.account.taxValue": "Steuerbetrag",
  "features.costsPrices.labels.jointCornerSquareMech": "Rechtwinklige Eckverbindung – mechanisch",
  "features.account.editCurrencies": "Währungen bearbeiten",
  "features.quotesAndOrders.acceptToView": "<Zum Anzeigen akzeptieren>",
  "features.account.currencies": "Währungen",
  "features.quotesAndOrders.saveProblem": "Beim Speichern dieses Auftrags ist ein Problem aufgetreten. Geben Sie die Auftragsdetails erneut ein.",
  "features.staff.branchUsersNonAdmin": "Benutzer der Filiale verfügen nicht über Administratorrechte.",
  "features.store.limitedSellingTimesProblem": "In einer Welt, in der alles immer schneller gehen muss, ist es eine Herausforderung, die Aufmerksamkeit potenzieller Kunden zu gewinnen und ihre Anforderungen sofort zu erfüllen.",
  "common.contact.company": "Unternehmen",
  "features.switchDesign.chooseAProduct": "Wählen Sie ein Produkt aus",
  "features.dashboard.allowMoreCustomers": "Ermöglichen Sie noch mehr Kunden, Angebote zu erstellen & Bestellungen aufzugeben.",
  "common.labels.extra": "Extra",
  "features.retailOptionsControl.tooltips.visibleOptions": "Anzeigeoptionen für den Retail Designer anpassen",
  "common.labels.document": "Dokument",
  "features.leadCapture.setup.companyDetailsAndSettings": "Unternehmensdaten & Einstellungen",
  "features.quotesAndOrders.cancelOrderConfirmTitle": "Sind Sie sicher? Die Stornierung kann nicht rückgängig gemacht werden.",
  "common.contact.address1": "Adresszeile 1",
  "features.customers.defaultTaxRateRequiredText": "Bitte wählen Sie einen Standardsteuersatz aus",
  "features.basket.removePriceTooltip": "Entferne {price}",
  "features.quotesAndOrders.discountAppliedToSubtotal": "Der Rabattcode {<u>{code}</u> wurde auf die Zwischensumme dieser Bestellung angewendet.",
  "features.designer.removeItemTitle": "Möchten Sie diesen Eintrag wirklich entfernen?",
  "features.chooseProduct.poweredBy": "Produkte und Daten bereitgestellt von",
  "features.costsPrices.editPriceName": "{description} {name} bearbeiten",
  "features.quotesAndOrders.orderPageTitle": "Aufträge suchen",
  "features.basket.consentDealer": "Aktivieren Sie das Kontrollkästchen, um zu bestätigen, dass die von Ihnen angegebenen Informationen an einen lokalen Fachpartner weitergeleitet werden dürfen. Dieser wird sich mit Ihnen in Verbindung setzen, um Ihre Anfrage zu besprechen.",
  "features.costsPrices.labels.numerals": "Ziffern",
  "features.designer.issuesClickForDetails": "{count} Probleme, hier klicken für weitere Details.",
  "features.chooseProduct.noPartsFound": "Keine Teile gefunden",
  "common.status.processing": "Verarbeitung",
  "features.designer.sandboxWarning": "Sie arbeiten jetzt in der Sandbox von {name}.",
  "common.status.live": "Live",
  "features.store.branchesDescription": "Mehrere Filialen? Mit QUOTILA Branches arbeitet jede Filiale unabhängig mit eigenen Funktionen für Angebote, Bestellungen und Kundenverwaltung.",
  "common.labels.no": "Nein",
  "features.marketing.saveCategory": "Kategorie speichern",
  "features.leadCapture.hero.expiringButtonDescription": "{brandedMode} kaufen",
  "features.quotesAndOrders.consumerDetailsEmailText": "Sobald die Daten des Endkunden erfasst wurden, können Sie ihm eine E-Mail senden.",
  "features.quotesAndOrders.quoteStage": "Angebotsphase",
  "features.basket.updateExtra": "Zusatzoption aktualisieren",
  "features.dashboard.knowledgeBase.enquire": "Jetzt anfragen",
  "features.kpi.generatedByYou": "von Ihnen generiert",
  "common.labels.contract": "Vertrag",
  "features.paymentGateway.businessProfile": "Unternehmensprofil",
  "features.news.from": "von",
  "common.labels.customer": "Kunde",
  "common.labels.category": "Kategorie",
  "features.switchDesign.noProductsToShow": "Keine Produkte zur Anzeige verfügbar",
  "common.labels.limit": "Limit",
  "features.quotesAndOrders.quoteStages": "Angebotsphasen",
  "features.basket.each": "jeweils",
  "common.labels.listOrder": "Reihenfolge der Liste",
  "features.basket.applyVoucherPrompt": "Gutscheincode auf dieses {type} anwenden?",
  "features.styling.tooltip.quotePDFLastPageImage": "Geben Sie hier den Inhalt ein, der auf der letzten Seite Ihres Angebots-PDFs angezeigt wird.",
  "features.news.newPost": "Neuer Beitrag",
  "common.labels.accountCode": "Kontonummer",
  "features.store.tradeWebsiteDescription": "Sprechen Sie den Fachhandel und Montagebetriebe mit einem informativen und benutzerfreundlichen Website-Design von Selecta Systems gezielt an. Mit vielen vollständig ausgearbeiteter Produktseiten stehen zusätzliche Erweiterungen zur Verfügung.",
  "features.designer.customDesigner.tabOpeners": "Öffnungselemente",
  "features.store.tradeWebsiteTheme": "Design der Händlerwebsite",
  "features.costsPrices.strategy1Step3Suffix": "Kosten und Preiskategorien zuweisen",
  "features.quotesAndOrders.pleaseEnterConsumerDetails": "Bitte geben Sie die Endkundendaten ein.",
  "features.customers.licenseLimitAccount": "Konto",
  "features.basket.deleteStockItemTitle": "Sind Sie sicher?",
  "features.costsPrices.labels.spacerBars": "Abstandshalter",
  "features.support.visitKnowledgeBase": "Besuchen Sie die Wissensdatenbank",
  "features.basket.overridingCurrencyNote": "Für diesen Vertrag wird die Währung des Kunden verwendet.",
  "common.datetime.endDate": "Enddatum",
  "common.contact.line2": "Zeile 2",
  "common.validation.rules.wholeNumber": "{field} muss eine ganze Zahl sein",
  "features.basket.notesLabel": "Geben Sie hier Ihre Anmerkungen ein.",
  "features.visualiser.uploadTip3": "Die Dateigröße darf 25 MB nicht überschreiten.",
  "common.errors.provideFeedback": "Bitte geben Sie uns Feedback...",
  "common.buttons.save": "Änderungen speichern",
  "features.store.homeVisualiser": "HOME VISUALISER",
  "features.checkout.supplierNotes": "Anmerkungen des Lieferanten",
  "features.checkout.deliveryNotes": "Lieferhinweise",
  "common.contact.primaryAddress": "Hauptadresse",
  "features.costsPrices.labels.upliftCost": "Aufschlagskosten",
  "features.costsPrices.stepCannotBeZero": "Schritt darf nicht leer oder 0 sein.",
  "features.customers.liveLicensed": "Live (lizenziert)",
  "common.contact.primary": "Primär",
  "features.basket.voucherAlreadyAppliedTitle": "Ein Gutscheincode wurde bereits eingelöst",
  "features.costsPrices.labels.reinforcing": "Verstärkung",
  "common.labels.reference": "Referenz",
  "features.leadCapture.company.enquiryOverdueLimit": "Frist für zugewiesene Anfragen",
  "features.branches.setPrimaryBranch": "Primäre Filiale festlegen",
  "common.global.privacyPolicy": "Datenschutzerklärung",
  "features.checkout.basketItems": "Warenkorb mit {qty} Artikeln",
  "features.styling.labels.quotePDFLastPageImage": "Bild für die letzte Seite des Angebots-PDFs",
  "common.status.redeemed": "Eingelöst",
  "common.buttons.add": "Hinzufügen",
  "features.support.dontShowAgain": "Nicht erneut anzeigen",
  "features.dashboard.checklist.step4": "4. Wählen Sie aus, wie Sie Ihre Preise festlegen möchten",
  "common.labels.onward": "Weiter",
  "features.costsPrices.deleteGroupConfirm": "Möchten Sie diese Gruppe wirklich löschen?",
  "features.customers.showFocItemsOnly": "Nur kostenfreie Artikel anzeigen",
  "features.kpi.orders": "Aufträge",
  "features.customers.quotaUsed": "{quota} -Kontingent aufgebraucht",
  "features.login.adminTitle": "QUOTILA-Admin",
  "common.menu.switchDesign": "Design wechseln",
  "features.store.moreBenefits": "Weitere Vorteile",
  "common.labels.inside": "Innen",
  "features.leadCapture.freeTrial.subscribePrompt": "Melden Sie sich mit einer der unten aufgeführten E-Mail-Adressen an Ihrem Administratorkonto an, um die kostenlose Testlizenz für die {company} Lead-Erfassung zu aktivieren.",
  "features.costsPrices.moveFinancialItemsWarning": "Bitte verschieben Sie alle preisrelevanten Einträge aus dieser Gruppe, bevor Sie sie löschen.",
  "features.login.emailVerificationSent": "Sie erhalten in Kürze eine E-Mail zur Bestätigung Ihrer E-Mail-Adresse.",
  "features.enquiries.assign": "Anfrage zuweisen",
  "common.menu.pricingSetup": "Preiskonfiguration",
  "features.quotesAndOrders.sendEmailNotification": "E-Mail-Benachrichtigung senden",
  "common.validation.cannotBeUndone": "Diese Aktion kann nicht rückgängig gemacht werden.",
  "features.customers.pricing": "Preise",
  "features.leadCapture.deployment.instruction": "Klicken Sie hier, um die Anleitung zur Einrichtung von {setup} aufzurufen.",
  "features.designer.reviewRequiredQuestions": "Bitte beantworten Sie uns die folgenden Fragen",
  "features.visualiser.uploadTip4": "Freie Sicht",
  "features.basket.enquirySummaryVisEmail": "Sie erhalten umgehend eine E-Mail mit einer Zusammenfassung Ihrer Anfrage und der Visualisierung Ihres Hauses.",
  "features.customers.licenseLimitReachedHtml": "Sie haben gemäß Ihrem Vertrag das Limit für Kundenlizenzen im QUOTILA-Portal erreicht. Bitte wenden Sie sich an {sales}, um Ihr Limit zu erhöhen.",
  "common.buttons.send": "Senden",
  "features.costsPrices.labels.jointCornerAngledMech": "Abgewinkelte Eckverbindung – mechanisch",
  "features.leadCapture.styling.virtualHomeBannerPurpose": "Starten Sie Virtual Home.",
  "features.customers.reportType": "Berichtstyp",
  "features.visualiser.visSavedText": "Die Visualisierung wurde dem Angebot hinzugefügt. Bitte vervollständigen Sie Ihr Angebot wie gewohnt.",
  "features.enquiries.convertToQuote": "In Angebot umwandeln",
  "features.store.buyStep3": "Für den Store registrieren",
  "features.store.selectaDescription1": "Generieren Sie Online-Anfragen mit dem Connect Window & Door Designer.",
  "features.quotesAndOrders.unableToDelete": "Löschen nicht möglich.",
  "features.customers.extruderLevels": "Extruder Level",
  "common.buttons.browse": "Durchsuchen",
  "features.login.loginErrorEmail": "Die Zahlung zusammen mit der Bestellung ist nicht möglich, wenn der SOP-Prozess übersprungen wird.",
  "common.global.maintenanceText": "Bitte versuchen Sie es in Kürze erneut",
  "features.customers.paymentWithOrder": "Zahlung bei Bestellung",
  "features.marketing.openExternalLinkText": "Möchten Sie die folgende URL-Adresse öffnen?",
  "features.designer.deleteProductTitle": "Produkt löschen",
  "features.costsPrices.labels.wastage": "Verschnitt",
  "features.account.approveOrdersWithWarningsTooltip": "Benutzer müssen Aufträge mit Positionen genehmigen, die Warnungen enthalten.",
  "features.account.allowProductRequoteMarkups": "Aufschläge für Neuangebote zulassen",
  "common.labels.enquiry": "Anfrage",
  "common.contact.name": "Name",
  "common.global.newVersionText": "Eine neue Version der Anwendung ist verfügbar. Bitte aktualisieren Sie die Seite.",
  "features.store.perBranchPerMonth": "pro Filiale/Monat",
  "common.menu.options": "Optionen",
  "common.financial.foc": "Kostenlos",
  "features.store.problemsHeading": "Als Unternehmen kennen wir die Herausforderungen, denen Sie täglich begegnen.",
  "common.validation.confirmSave": "Speichern bestätigen",
  "features.visualiser.homeImages": "Ihre Hausbilder",
  "common.labels.view": "Anzeigen",
  "features.designer.atLeastMm": "min. {min}mm",
  "features.checkout.privacyConsent": "Bevor Sie dieses Kontrollkästchen aktivieren, klicken Sie auf {clickHere}, um weitere Informationen zur Verwendung Ihrer personenbezogenen Daten zu erhalten. Mit der Aktivierung dieses Kontrollkästchens bestätigen Sie, dass Sie unsere {privacyPolicy} und {termsAndConditions} gelesen haben und ihnen zustimmen.",
  "features.customers.licenseEnabled": "Lizenz aktiviert",
  "features.customers.searchItems": "Artikel suchen...",
  "features.delivery.deliveryOption": "Lieferoption",
  "features.leadCapture.styling.thankYouPageText": "{setup} Text der Dankesseite",
  "features.costsPrices.labels.bottomLeftCost": "Kosten unten links",
  "features.launch.designUnavailable": "Diese Design-Software ist vorübergehend nicht verfügbar.",
  "common.contact.deliveryAddress": "Lieferadresse",
  "features.costsPrices.labels.baseCost": "Grundkosten",
  "features.quotesAndOrders.createTest": "Test erstellen",
  "features.retailOptionsControl.tooltips.hiddenOptions": "Ausgeblendete Optionen zum Retail Designer hinzufügen",
  "features.costsPrices.labels.maxHeightShort": "Maximale Höhe",
  "features.login.passwordResetSent": "Anfrage zur Passwortzurücksetzung gesendet",
  "features.enquiries.referral": "Empfehlung",
  "features.store.featureReInputOrdersText": "Jede Anfrage, die Sie über {brandedMode} erstellen, kann direkt an das {fabricator}-Portal übergeben und dort in ein Angebot umgewandelt werden. Anschließend können Sie Optionen anpassen und Preise hinzufügen, ohne die Anfrage des Kunden erneut erfassen zu müssen.",
  "features.delivery.leadTime": "Lieferzeit",
  "common.global.maintenanceTitle": "Das System wird derzeit gewartet.",
  "features.costsPrices.deleteItemConfirm": "Möchten Sie diesen Eintrag wirklich löschen?",
  "features.store.discoverMoreLeadCapture": "Erfahren Sie mehr über {brandedMode}",
  "features.paymentGateway.accountIdentifier": "Konto-ID",
  "features.designer.modelError": "Fehler im 3D-Modell",
  "features.account.noCurrenciesToShow": "Keine Währungen vorhanden",
  "common.buttons.DragDrop": "Drag & drop",
  "features.quotesAndOrders.adjustPrice": "Preis anpassen",
  "features.leadCapture.company.googleAnalytics.step1": "Geben Sie den auf Ihrer Website eingebetteten gtag-Code an.",
  "features.quotesAndOrders.marginOnProducts": "Marge auf Produkte",
  "common.status.started": "Gestartet",
  "features.branches.branchName": "Filialname",
  "common.labels.days": "Tage",
  "features.quotesAndOrders.ordersTitle": "{orderStatus} Aufträge",
  "features.costsPrices.labels.minWidth": "Minimale Breite",
  "features.news.noMatchSearch": "Es wurden keine Newsartikel gefunden, die {search} entsprechen.",
  "features.styling.labels.emailBodyText": "E‑Mail‑Nachricht",
  "features.store.buyEnquireNow": "Jetzt kaufen / Anfragen stellen",
  "features.designer.customDesigner.tabDummiesMidrails": "Dummies/Mittelschienen",
  "features.support.freeHelpAndSupport": "Kostenlose Hilfe & Support",
  "features.news.editCategory": "Kategorie bearbeiten",
  "features.marketing.videoUrl": "Video-URL",
  "features.branches.addBranch": "Filiale hinzufügen",
  "common.labels.optionGroups": "Optionsgruppen",
  "common.datetime.monday": "Montag",
  "common.financial.paymentFailed": "Zahlung fehlgeschlagen",
  "features.costsPrices.labels.maxHeight": "Maximale Höhe",
  "features.costsPrices.labels.bottomLeftPrice": "Preis unten links",
  "features.leadCapture.hero.expiringLine2": "Unterstützte Lizenz",
  "common.labels.any": "Beliebig",
  "features.checkout.basketItem": "Warenkorb mit {qty} Artikel",
  "common.validation.passwordsNoMatch": "Passwörter stimmen nicht überein.",
  "features.marketing.confirmDeleteItem": "Möchten Sie diesen Eintrag wirklich löschen?",
  "features.chooseProduct.chooseAProduct": "Wählen Sie ein Produkt aus",
  "features.costsPrices.strategy2Step2Prefix": "Hinzufügen",
  "features.staff.staffLicenses": "Mitarbeiterlizenzen",
  "features.quotesAndOrders.calculationBreakdown": "Kalkulationsaufschlüsselung",
  "common.datetime.saturday": "Samstag",
  "common.status.na": "N/A",
  "features.costsPrices.labels.height": "Höhe",
  "features.customers.unsavedHeadingChanges": "In dieser Optionsüberschrift gibt es nicht gespeicherte Änderungen.",
  "features.designer.customDesigner.tabCreateDesign": "Design erstellen",
  "common.datetime.th": "Do",
  "features.costsPrices.labels.basePrice": "Grundpreis"
}